import React, { useState, useEffect, useRef, useDebugValue } from "react";
import "./chatbot.css";
import chatavatr from "../../assets/img/chatbot_logo.png";
import loader from "../../assets/img/loader.gif";
import placeholder from "../../assets/img/Chatbot_Placeholder.gif";
import IClose from "../../assets/img/ico-close.png";
import IExp from "../../assets/img/ico-expand.png";
import IRefresh from "../../assets/img/ico-referesh.png";
import { ReactComponent as NovaIcon } from "../../assets/svg/nova_icon.svg";
import { ReactComponent as ClaudeIcon } from "../../assets/svg/claude_icon.svg";
import { ReactComponent as GemmaIcon } from "../../assets/svg/gemini_icon.svg";
import axios from "axios";
import parse from "html-react-parser";
import { useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import Config from "../../Config.json";
import CommonObj from "../../CommonObj";
import DOMPurify from "dompurify";
import { IoTEventsData } from "aws-sdk";
import ReactMarkdown from "react-markdown";
import { useToast } from "../../context/ToastContext.jsx";
import remarkGfm from 'remark-gfm';

let commentValidation = false;
const ChatBot = () => {
  const { showToast } = useToast();
  const [searchParams] = useSearchParams();
  const [isTall, setIsTall] = useState(true);
  const [isMinimized, setIsMinimized] = useState(false);
  const [activeTab, setActiveTab] = useState(CommonObj.TransactionName);
  const [showLeavesFlow, setShowLeavesFlow] = useState(false);
  const [applyStep, setApplyStep] = useState(0);
  const [querymessages, setQueryMessages] = useState([]);
  const [transactionmessages, setTransactionmessages] = useState([]); // Stores the chat history
  const [policymessages, setPolicymessages] = useState([]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);
  const scrollRef = useRef(null);
  const categories = [
    CommonObj.TransactionName,
    CommonObj.Question,
    //CommonObj.PolicyName,
  ];
  const [itemName, setItemName] = useState("");
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [conversationID, setConversationID] = useState(0);
  const [ResponseID, setResponseID] = useState(0);
  const inputRef = useRef(null);
  const [WelcomeMessage, SetWelcomeMessage] = useState("");
  const [showReset, setShowReset] = useState(false);
  const [showNoUpdate, setShowNoUpdate] = useState(false);
  const [isAiMode, setIsAiMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [information, setInformation] = useState(false);
  const [pdfSample, setPdfSample] = useState(CommonObj.SamplePdfFile);
  const [isSatifaction, setIsSatifaction] = useState(false);
  //const [commentValidation, setCommentValidation] = useState(false);
  const [disabledSend, setDisabledSend] = useState(true);
  const [botAuthToken, setBothAuthToken] = useState("");
  const [ChatbotAuthToken, setChatBothAuthToken] = useState("");
  const [feedbackIndex,SetFeedbackIndex] = useState(0);
  const [isFirstLogin,setisFirstLogin] = useState(true);
  const [policymailid,setpolicymailid] = useState("");
  const [mngId ,setMngrId] = useState("");
  const [defaultMode,setDefaultModel]=useState(false);

  const feedbackOptions = [
    "Missing critical details",
    "Wrong Information",
    "Irrelevant Content",
    "Something Else",
  ];
const MailGroup = {
    1: "hrsharedservices.chennai@rrd.com",
    2: "hrsharedservices.trivandrum@rrd.com",
    3: "hrdmanilaot@rrd.com",
    4: "hr.srilanka@rrd.com",
    6: "hrsharedservices.chennai@rrd.com",
    7: "hrsharedservices.chennai@rrd.com",
    8: "hrsharedservices.chennai@rrd.com",
    9: "hrsharedservices.chennai@rrd.com",
    10: "hrsharedservices.chennai@rrd.com",
    11: "hrsupportindia@williamslea.com",
    12: "hrsupportindia@williamslea.com",
    13: "hrsupportindia@williamslea.com",
    14: "hrsupportindia@williamslea.com",
    15: "hrsupportindia@williamslea.com",
    16: "hrsupportindia@williamslea.com"
}
  const LocationGroup = {
    1: "CHN",
    2: "TRV",
    3: "MNL",
    4: "CMB",
    6: "BLR",
    7: "US",
    8: "JPN",
    9: "VAL",
    10: "CBE",
    11: "HYD",
    12: "MUM",
    13: "DEL",
    14: "KOC",
    15: "CHN",
    16: "BLR",
  };
  const leaveData = [
    { type: "Casual", total: 12, taken: "02", balance: 10 },
    { type: "Comp Off", total: 0, taken: 0, balance: 0 },
    { type: "Vacation", total: 43, taken: 0, balance: 43 },
  ];

  const SubmitFeedback = async () => {
    try {
      if (
        (selectedFeedback == null || selectedFeedback == "Something Else") &&
        feedbackText.length == 0
      )
        commentValidation = true;
      else commentValidation = false;

      const payload = {
        ConversationId: conversationID,
        ResponseID: ResponseID,
        feedback: selectedFeedback === null ? "Others" : selectedFeedback,
        feedbackcomments: feedbackText,
        EmployeeID: itemName.split("~")[0],
        feedbacktype : isSatifaction ? "Like" : "DisLike"
      };

      if (!commentValidation | isSatifaction) {
        const response = await axios.post(
          Config.ChatbaseUrl + "/api/ChatBot/UpdateChatbotFeedback",
          payload,
          {
            headers: {
              "X-Bot-Authorization": botAuthToken,
              Authorization: "Bearer " + ChatbotAuthToken,
            },
          },
        );
        if (response) {
          updateFeedback();
          showToast(
            "Success",
            "Feedback added successfully",
            CommonObj.Toast_Types.SUCCESS,
          );
          //setCommentValidation(false);
          commentValidation = false;
          setShowFeedbackModal(false);
          setInput("");
        }
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const getInitials = (name) => {
    if (!name) return "";

    // 1. Trim whitespace and split by one or more spaces
    const parts = name.trim().split(/\s+/);

    if (parts.length === 0) return "";

    // 2. Get the first letter of the first word
    const firstInitial = parts[0].charAt(0).toUpperCase();

    // 3. If there's more than one word, get the first letter of the last word
    if (parts.length > 1) {
      const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
      return `${firstInitial}${lastInitial}`;
    }

    return firstInitial;
  };
  const transactionActions = [
    { id: "leaves", label: "Leave Management", fullWidth: false },
    { id: "search", label: "Search Employee", fullWidth: false },
    { id: "address proof", label: "Address Proof", fullWidth: false },
    { id: "holidays", label: "Holidays", fullWidth: false },
    { id: "password", label: "Password Management", fullWidth: true },
  ];

  const moduleQueries = [
    { id: "leave", label: "Leave", icon: "🗓️" },
    { id: "attendance", label: "Attendance", icon: "🆔" },
    { id: "meal", label: "Meal", icon: "🍱" },
    { id: "cab", label: "Cab", icon: "🚗" },
    { id: "support", label: "Support", icon: "🎧" },
    { id: "touchstone", label: "Touchstone", icon: "💡" },
    { id: "finance", label: "Finance", icon: "💰" },
  ];

  const decryptEmployeeId = () => {
    try {
      const conss = searchParams.get("UserId");
      const inputstring = conss.replace(/ /g, "+");
      const secretKey = "IejTfE4hH9oMaOGt";
      const key = CryptoJS.enc.Utf8.parse(secretKey);
      const bytes = CryptoJS.AES.decrypt(inputstring, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedData) throw new Error("Decryption failed - check key/mode");

      setItemName(decryptedData);
    } catch (error) {
      console.error("Error during decryption:", error.message);
      return null;
    }
  };

  const FocusTextBox = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const UserName = getInitials(itemName.split("~")[1]);
  const PDFModal = ({ isOpen, onClose, pdfUrl }) => {
    if (!isOpen) return null;

    return (
      <div className="modalOverlayStyle" onClick={onClose}>
        <div className="modalContentStyle" onClick={(e) => e.stopPropagation()}>
          <button className="closeButtonStyle" onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M13.5 4.5L4.5 13.5"
                stroke="#002449"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.5 4.5L13.5 13.5"
                stroke="#002449"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <iframe
            src={`${pdfUrl}#toolbar=0`}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
      </div>
    );
  };

  window.getdata = function (element) {
    const value = element.textContent;
    handleSend(value);
  };

  window.getinputdata = function (data) {
    handleSend(data);
  };

  window.viewPolicyDocment = function (fileUrl) {
    window.parent.postMessage("HIDE_IMAGE", "*");
    setIsModalOpen(true);
    setPdfSample(fileUrl);
  };

  const getChatBotAuth = async () => {
    try {
      if (itemName !== "") {
        var payload = {
          inputmessage: "",
          empid: itemName.split("~")[0],
          mngId: "",
          conversationID: 0,
          domain :"As",
          ssocheck : "n"
        };
        const response = await axios.post(
          Config.ChatbaseUrl +
            "/api/Authentication/GenerateTransactionBotToken",
          payload,
        );
        const token = response.data.accessToken;
        if (token != null) {
          setChatBothAuthToken(token);
        }
      }
    } catch (error) {}
  };

  const updateFeedback = () => {
  const isPossitive= isSatifaction ? "true" : "false";
   if (activeTab === CommonObj.Question) {
    const updatedMessages = querymessages.map((msg, index) => {
      if (index === feedbackIndex) {
        return { ...msg, isFeedback: isPossitive };
      }
      return msg;
    });
    setQueryMessages(updatedMessages)
  }
  else if (activeTab === CommonObj.TransactionName) {
    const updatedMessages = transactionmessages.map((msg, index) => {
      if (index === feedbackIndex) {
        return { ...msg, isFeedback: isPossitive };
      }
      return msg;
    });
    setTransactionmessages(updatedMessages)
  }
  };

  const getAskQueryBotAuth = async () => {
    try {
      var payload = {
        inputmessage: "",
        empid: itemName.split("~")[0],
        mngId: "",
        conversationID: 0,
      };
      const response = await axios.post(
        Config.ChatbaseUrl + "/api/Authentication/GenerateAskQueryBotToken",
        payload,
      );
      const token = response.data.access_token;
      if (token != null) {
        setBothAuthToken(token);
      }
    } catch (error) {}
  };
  useEffect(() => {
    decryptEmployeeId();
    if(itemName.split("~")[0]!=='')
    {
    const locationid = itemName.split("~")[3];
    const location = MailGroup[locationid] || "HR";
    setpolicymailid(location);
    setisFirstLogin(true);
    getChatBotAuth();
    getAskQueryBotAuth();
    }
  }, [itemName]);

  useEffect(() => {
    scrollToBottom();
  }, [querymessages, transactionmessages, policymessages]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    FocusTextBox();
    if (
      querymessages.length > 0 ||
      transactionmessages.length > 0 ||
      policymessages.length > 0
    )
      SetWelcomeMessage("no-welcome-message");
    else SetWelcomeMessage("");
  }, [querymessages, transactionmessages, policymessages, activeTab]);

  const handleSend = async (validinput) => {
    const chatinput = validinput || input;
    const inputvalues = chatinput.replace("›", "");
    if (chatinput.trim() !== "") {
      const userMessage = { text: inputvalues, sender: "user" };
      const constmessage = '<div class="loader"></div>';

      if (activeTab === CommonObj.Question) {
        setQueryMessages((prev) => [...prev, userMessage]);
        const botmsg = { text: constmessage, sender: "bot", responseId: 0 };
        setQueryMessages((prev) => [...prev, botmsg]);

        const currentInput = inputvalues;
        setInput("");
        try {
          const locationid = itemName.split("~")[3];
          const location = LocationGroup[locationid] || 1;
          const empid = itemName.split("~")[0];
          const selectedvalues = empid.includes("WL")
            ? "STG-WLL-" + location
            : "STG-RRD-" + location;
          const payload = {
            question: currentInput,
            selected: selectedvalues,
            conversationID: conversationID,
            empid: itemName.split("~")[0],
            model : activeModelKey
                };
          const response = await axios.post(
            Config.ChatbaseUrl + "/api/ChatBot/GetQueryResponse",
            payload,
            {
              headers: {
                "X-Bot-Authorization": botAuthToken,
                Authorization: "Bearer " + ChatbotAuthToken,
              },
            },
          );
          if(response.data.detail === "Invalid or expired token")
          {
            getAskQueryBotAuth();
             const response = await axios.post(
            Config.ChatbaseUrl + "/api/ChatBot/GetQueryResponse",
            payload,
            {
              headers: {
                "X-Bot-Authorization": botAuthToken,
                Authorization: "Bearer " + ChatbotAuthToken,
              },
            },
          );    
          response.data.answer = response.data.answer.replaceAll("## ", " ");
          if(response.data.toggle == true)
          {
            response.data.answer = response.data.answer.replaceAll(itemName.split("~")[0],itemName.split("~")[1])
          }
          
          const botMessage = {
            text: response.data.answer,
            sender: "bot",
            responseId: response.data.responseID,
            isFeedback : "",
            documents : response.data.doc_name !=null?response.data.doc_name:[]
          };
          setQueryMessages((prev) => [...prev, botMessage]);
          setConversationID(response.data.conversationID);
          setQueryMessages((prev) =>
            prev.filter((msg) => msg.text !== constmessage),
          );      
          }
          else
          {
          response.data.answer = response.data.answer.replaceAll("## ", " ");
          if(response.data.toggle == true)
          {
            response.data.answer = response.data.answer.replaceAll(itemName.split("~")[0],itemName.split("~")[1])
          }
          
          const botMessage = {
            text: response.data.answer,
            sender: "bot",
            responseId: response.data.responseID,
            isFeedback : "",
            documents : response.data.doc_name !=null?response.data.doc_name:[]
          };
          setQueryMessages((prev) => [...prev, botMessage]);
          setConversationID(response.data.conversationID);
          setQueryMessages((prev) =>
            prev.filter((msg) => msg.text !== constmessage),
          );
        }
        } catch (error) {
          if (error.response?.status === 401) {
            getChatBotAuth();
           }
          const botMessage = {
            text: "",
            sender: "bot",
          };
          setQueryMessages((prev) => [...prev, botMessage]);
          setQueryMessages((prev) =>
            prev.filter((msg) => msg.text !== constmessage),
          );
          console.error("Error posting data:", error);
        }
      } else if (activeTab === CommonObj.TransactionName) {
        setTransactionmessages((prev) => [...prev, userMessage]);
        const currentInput = inputvalues;
        setInput("");

        const botmsg = { text: constmessage, sender: "bot" };
        setTransactionmessages((prev) => [...prev, botmsg]);
        try {
          const payload = {
            inputmessage: currentInput,
            empid: itemName.split("~")[0],
            mngId: mngId,
            conversationID: conversationID,
            isFirstLogin : isFirstLogin
          };
          const response = await axios.post(
            Config.ChatbaseUrl + "/api/ChatBot/GetResponse",
            payload,
            {
              headers: {
                Authorization: "Bearer " + ChatbotAuthToken,
                "X-Bot-Authorization": botAuthToken,
              },
            },
          );
          
          const botMessage = {
            text: response.data.answer,
            sender: "bot",
            responseId: response.data.responseID,
            isFeedback : ""
          };
          setMngrId(response.data.mngrId)
          setTransactionmessages((prev) => [...prev, botMessage]);
          setConversationID(response.data.conversationID);
          setTransactionmessages((prev) =>
            prev.filter((msg) => msg.text !== constmessage),
          );
          setisFirstLogin(false);
        } catch (error) {
          if (error.response?.status === 401) {
            getChatBotAuth();
           }
          const botMessage = {
            text: CommonObj.CommonValidationMsg,
            sender: "bot",
          };
          setTransactionmessages((prev) => [...prev, botMessage]);
          setTransactionmessages((prev) =>
            prev.filter((msg) => msg.text !== constmessage),
          );
          console.error("Error posting data:", error);
        }
      } else if (activeTab === CommonObj.PolicyName) {
        PolicyInitialFun(inputvalues);
      }
    }
  };

  const PolicyInitialFun = async (policyinput) => {
    const userMessage = {
      text: policyinput == "" ? "policy documents" : policyinput,
      sender: "user",
    };
    setPolicymessages((prev) => [...prev, userMessage]);
    const currentInput = policyinput == "" ? "policy documents" : policyinput;
    setInput("");
    try {
      const payload = {
        inputmessage: currentInput,
        empid: itemName.split("~")[0],
        mngId: itemName.split("~")[2],
        conversationID: conversationID,
      };
      const response = await axios.post(
        Config.ChatbaseUrl + "/api/ChatBot/GetResponse",
        payload,
      );
      const botMessage = { text: response.data.answer, sender: "bot" };
      setPolicymessages((prev) => [...prev, botMessage]);
      setConversationID(response.data.conversationID);
    } catch (error) {
      const botMessage = { text: CommonObj.CommonValidationMsg, sender: "bot" };
      setPolicymessages((prev) => [...prev, botMessage]);
      console.error("Error posting data:", error);
    }
  };

  const resetChat = () => {
    setTransactionmessages([]);
    setQueryMessages([]);
    setPolicymessages([]);
    setActiveTab(CommonObj.TransactionName);
    FocusTextBox();
    setShowReset(false);
    setisFirstLogin(true);
  };

  const btnSubmit = () => {
    handleSend(input);
  };
  const openDiscoverPolicies = () => {
    window.open(Config.DiscoverPolicyURL, "_blank", "noopener,noreferrer");
  };
  const openDefaultPolicies = () => {
    window.open(Config.DefaultPolicyURL, "_blank", "noopener,noreferrer");
  };
  const RenderHTML = ({ htmlContent }) => (
    <div
      dangerouslySetInnerHTML={{
        __html: htmlContent,
      }}
    />
    );

    const closePDFModal = () => {
        setIsModalOpen(false);
        window.parent.postMessage("SHOW_IMAGE", "*");
    }


    // --- Models Specification ---
    const MODELS = {
        nova: {
            id: 'nova',
            shortName: 'Nova Lite',
            fullName: 'Nova Lite',          
            icon: NovaIcon 
        },
        claude: {
            id: 'claude',
            shortName: 'Claude 4.6',
            fullName: 'Claude Sonnet 4.6',
            icon: ClaudeIcon ,
        },
        gemma: {
            id: 'gemma',
            shortName: 'Gemma 3',
            fullName: 'Gemma 3',
            icon: GemmaIcon,
        }
    };

    const [dropdownOpen, setDropdownOpen] = useState(true); // Default open matching user screenshot specification
    const [activeModelKey, setActiveModelKey] = useState('claude');
    const [chatInput, setChatInput] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const dropdownRef = useRef(null);
    const activeModel = MODELS[activeModelKey];
    const ActiveModelIcon = activeModel.icon;

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

  const btnClearClick = () => {
    if (
      activeTab == CommonObj.TransactionName &&
      transactionmessages.length == 0
    )
      setShowNoUpdate(true);
    else if (activeTab == CommonObj.Question && querymessages.length == 0)
      setShowNoUpdate(true);
    else {
      setIsAiMode(false);
      setShowReset(true);
    }
  };

  if (!isMinimized) {
    return (
      <div className={`chatbot-card ${isTall ? "tall-mode" : ""}`}>
        <div className="chatbot-card-inner">
          <div className={`fixed-header-top ${WelcomeMessage}`}>
            <div className="header-icon-bar">                    
              <div className="header-left-title">
                <h6 className="amigo-text-gradient">Amigo</h6>
              <span className="amigo-version">Beta</span>
              </div>
              {defaultMode === true && (
                        <div className="dropdown-container" ref={dropdownRef}>
                            <button
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                                className="dropdown-trigger-btn"
                            >
                                <span className="dropdown-active-icon-container">
                                    <ActiveModelIcon className="w-5 h-5 animate-spin-slow" />
                                </span>

                                <span className="dropdown-active-name">
                                    {activeModel.shortName}
                                </span>

                                {/* Chevron icon rotates dynamically based on open state */}
                                {dropdownOpen ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <rect width="14" height="14" rx="7" transform="matrix(1 0 0 -1 0 14)" fill="#F1FBFF" />
                                        <path d="M3.5 8.75L7 5.25L10.5 8.75" stroke="#009DDB" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                ): (
                                        <svg className = "chevron-icon" xmlns = "http://www.w3.org/2000/svg" width = "14" height = "14" viewBox = "0 0 14 14" fill = "none">
                                    <path d = "M10.5 5.25L7 8.75L3.5 5.25" stroke = "#002449" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>                                        
                                     )}
                            </button>

                            {/* Dropdown Menu Container (Matches exact spec from screenshot) */}
                            

                                                          <div
                                className={`dropdown-menu-card ${dropdownOpen ? 'open' : 'closed'}`}
                            >
                                {Object.keys(MODELS).map((key) => {
                                    const item = MODELS[key];
                                    const ItemIcon = item.icon;
                                    const isSelected = activeModelKey === key;

                                    return (
                                        <button
                                            key={key}
                                            onClick={() => {
                                                setActiveModelKey(key);
                                                setDropdownOpen(false);
                                            }}
                                            className={`model-option-btn ${isSelected ? 'selected' : ''}`}
                                        >
                                            <div className="model-option-content">
                                                <span className="model-option-icon-wrapper">
                                                    <ItemIcon className="w-6 h-6" />
                                                </span>
                                                <span
                                                    className={`model-option-label ${isSelected ? 'active' : ''}`}
                                                >
                                                    {item.fullName}
                                                </span>
                                            </div>

                                            {/* Checkmark Status Indicator */}
                                            {isSelected && (
                                                <span className="check-indicator">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <g filter="url(#filter0_i_892_8363)">
                                                            <path d="M7 0C3.15 0 0 3.15 0 7C0 10.85 3.15 14 7 14C10.85 14 14 10.85 14 7C14 3.15 10.85 0 7 0Z" fill="#03C382" />
                                                        </g>
                                                        <path d="M4.20117 7.5333L5.91228 9.3333L9.33451 5.1333" fill="#03C382" />
                                                        <path d="M4.20117 7.5333L5.91228 9.3333L9.33451 5.1333" stroke="#ECF3F1" stroke-linecap="round" stroke-linejoin="round" />
                                                        <defs>
                                                            <filter id="filter0_i_892_8363" x="0" y="0" width="14" height="15.7883" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                                <feOffset dy="1.78827" />
                                                                <feGaussianBlur stdDeviation="1.3412" />
                                                                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.62 0" />
                                                                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_892_8363" />
                                                            </filter>
                                                        </defs>
                                                    </svg>
                                                </span>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                          
                        </div>
              )}
                              
              <div className="header-right-icons">
                <span className="icon-btn">
                  <img
                    src={IExp}
                    alt="Size"
                    className="header-bot-img"
                    title="Resize"
                  />
                </span>
                <span role="button" tabIndex="1" className="icon-btn" onClick={btnClearClick}>
                  <img
                    src={IRefresh}
                    alt="Reset"
                    className="header-bot-img"
                    title="Clear"
                  />
                </span>
                <span className="icon-btn">
                  <img
                    src={IClose}
                    alt="Close"
                    className="header-bot-img"
                    title="Close"
                  />
                </span>
              </div>
            </div>
            <div className="bot-profile-header fade-in">
              <div className="avatar-circle">
                <img src={loader} alt="Bot" />
              </div>
             
              <h6 className="amigo-text-gradient">Amigo</h6>
              <span className="amigo-version">Beta</span>
              <h3 className="welcome-name">Welcome, {itemName.split("~")[1]} !</h3>
              <p className="instruction-text">
                I'm here to help with your leave details, policies & more.
                <br />
                Pick an option below or type your question to get started!
              </p>
            </div>
            {/* <button
              className="dv_supportTag buttonStyle"
              onClick={() => setIsModalOpen(true)}
            >
              View Support Document
            </button> */}

            <PDFModal
              isOpen={isModalOpen}
              onClose={() => closePDFModal()}
              pdfUrl={pdfSample}
            />
          </div>
          <>
            {showFeedbackModal && (
              <div className="feedback-modal-overlay fade-in">
                <div className="feedback-card">
                  <h3 className="feedback-title">Feedback Matters</h3>
                  <p className="feedback-subtitle">
                    Your feedback will help us improve.
                  </p>

                  <div className="feedback-options-grid">
                    {!isSatifaction &&
                      feedbackOptions.map((opt) => (
                        <button
                          key={opt}
                          className={`feedback-pill ${selectedFeedback === opt ? "active" : ""}`}
                          onClick={() => setSelectedFeedback(opt)}
                        >
                          {selectedFeedback === opt && (
                            <span className="check-mark">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_371_887)">
                                  <circle
                                    cx="7.99992"
                                    cy="8.00004"
                                    r="6.66667"
                                    fill="#CAFFD8"
                                    stroke="#5BCD7A"
                                    stroke-width="1.2"
                                  />
                                  <path
                                    d="M5.66675 8.33337L7.00008 9.66671L10.3334 6.33337"
                                    stroke="#229100"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_371_887">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                          )}{" "}
                          {opt}
                        </button>
                      ))}
                  </div>
                  {!isSatifaction && selectedFeedback === "Something Else" && (
                    <div className="feedback-textarea-container fade-in">
                      <textarea
                        className="feedback-textarea"
                        placeholder="Please provide your valuable feedback here"
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                      ></textarea>
                      {commentValidation && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          Please provide your valuable feedback.
                        </span>
                      )}
                    </div>
                  )}

                  {isSatifaction && (
                    <div className="feedback-textarea-container fade-in">
                      <textarea
                        className="feedback-textarea"
                        placeholder="What did you appreciate most about this interaction?"
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                      ></textarea>
                    </div>
                  )}

                  <div className="feedback-actions">
                    <div className="cancel-stack">
                      <button
                        className="btn-cancel"
                        onClick={() => {
                          //setCommentValidation(false);
                          commentValidation = false;
                          setShowFeedbackModal(false);
                          setInput("");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                    <button
                      className="btn-submit-gradient"
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      onClick={() => {
                        SubmitFeedback();
                      }}
                    >
                      Submit{" "}
                      <span className="arrow-btn">
                        {isHovered && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M8 0C8 0 8.73129 4.18227 10.3529 5.80392C11.9746 7.42557 16 8 16 8C16 8 11.9746 8.57443 10.3529 10.1961C8.73129 11.8177 8 16 8 16C8 16 7.58244 11.8177 5.96078 10.1961C4.33913 8.57443 0 8 0 8C0 8 4.33913 7.42557 5.96078 5.80392C7.58244 4.18227 8 0 8 0Z"
                              fill="white"
                            />
                          </svg>
                        )}
                        {!isHovered && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="7"
                            height="16"
                            viewBox="0 0 7 16"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_371_1181)">
                              <path
                                d="M0 0C0 0 0.731291 4.18227 2.35294 5.80392C3.97459 7.42557 8 8 8 8C8 8 3.97459 8.57443 2.35294 10.1961C0.731291 11.8177 0 16 0 16C0 16 -0.417564 11.8177 -2.03922 10.1961C-3.66087 8.57443 -8 8 -8 8C-8 8 -3.66087 7.42557 -2.03922 5.80392C-0.417564 4.18227 0 0 0 0Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_371_1181">
                                <rect width="8" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showReset && (
              <div className="feedback-modal-overlay fade-in">
                <div className="feedback-card reset">
                  <div className="avatar-circle-chat aimode">
                    <span className="bot-side-avatar aimode">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <rect
                          width="14"
                          height="14"
                          rx="7"
                          fill="white"
                          fill-opacity="0.7"
                        />
                        <path
                          opacity="0.5"
                          d="M7.22266 4.90039V7.2214L8.67315 8.67204"
                          stroke="#002449"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.51092 3.51106L3.08664 3.08682L3.08664 3.08682L3.51092 3.51106ZM2.77617 4.24588L2.17617 4.2489C2.17783 4.57791 2.44414 4.84422 2.77315 4.84587L2.77617 4.24588ZM4.25008 4.8533C4.58144 4.85496 4.85142 4.58769 4.85309 4.25632C4.85475 3.92495 4.58747 3.65498 4.25611 3.65331L4.25309 4.2533L4.25008 4.8533ZM3.36874 2.7658C3.36707 2.43444 3.0971 2.16716 2.76573 2.16882C2.43436 2.17049 2.16709 2.44047 2.16875 2.77183L2.76874 2.76882L3.36874 2.7658ZM2.64292 6.5396C2.68792 6.21129 2.45825 5.90868 2.12995 5.86368C1.80165 5.81869 1.49903 6.04835 1.45404 6.37665L2.04848 6.45812L2.64292 6.5396ZM10.8955 3.54817L11.3198 3.12393C9.04009 0.84397 5.35393 0.819312 3.08664 3.08682L3.51092 3.51106L3.9352 3.9353C5.72584 2.1445 8.6521 2.15308 10.4713 3.97242L10.8955 3.54817ZM3.54803 10.8964L3.12374 11.3206C5.40349 13.6006 9.08965 13.6252 11.3569 11.3577L10.9327 10.9335L10.5084 10.5092C8.71774 12.3 5.79148 12.2915 3.97231 10.4721L3.54803 10.8964ZM10.9327 10.9335L11.3569 11.3577C13.6242 9.09027 13.5995 5.40386 11.3198 3.12393L10.8955 3.54817L10.4713 3.97242C12.2905 5.79178 12.299 8.71842 10.5084 10.5092L10.9327 10.9335ZM3.51092 3.51106L3.08664 3.08682L2.35188 3.82164L2.77617 4.24588L3.20045 4.67013L3.9352 3.9353L3.51092 3.51106ZM2.77617 4.24588L2.77315 4.84587L4.25008 4.8533L4.25309 4.2533L4.25611 3.65331L2.77918 3.64589L2.77617 4.24588ZM2.77617 4.24588L3.37616 4.24287L3.36874 2.7658L2.76874 2.76882L2.16875 2.77183L2.17617 4.2489L2.77617 4.24588ZM2.04848 6.45812L1.45404 6.37665C1.21438 8.12527 1.77254 9.9693 3.12374 11.3206L3.54803 10.8964L3.97231 10.4721C2.89571 9.39544 2.45242 7.92956 2.64292 6.5396L2.04848 6.45812Z"
                          fill="#002449"
                        />
                      </svg>
                    </span>
                    <span className="head_text">Confirmation message</span>
                  </div>
                  <p className="feedback-subtitle reset">
                    Do you want to clear the chats for both the tabs (Quick Actions & Ask a Question)?
                  </p>
                  <div className="feedback-actions reset">
                    <div className="cancel-stack">
                      <button
                        className="btn-cancel"
                        onClick={() => setShowReset(false)}
                      >
                        Cancel
                      </button>
                    </div>
                    <button
                      className="btn-submit-gradient"
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      onClick={() => resetChat()}
                    >
                      Proceed{" "}
                      <span className="arrow-btn">
                        {isHovered && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M8 0C8 0 8.73129 4.18227 10.3529 5.80392C11.9746 7.42557 16 8 16 8C16 8 11.9746 8.57443 10.3529 10.1961C8.73129 11.8177 8 16 8 16C8 16 7.58244 11.8177 5.96078 10.1961C4.33913 8.57443 0 8 0 8C0 8 4.33913 7.42557 5.96078 5.80392C7.58244 4.18227 8 0 8 0Z"
                              fill="white"
                            />
                          </svg>
                        )}
                        {!isHovered && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="7"
                            height="16"
                            viewBox="0 0 7 16"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_371_1181)">
                              <path
                                d="M0 0C0 0 0.731291 4.18227 2.35294 5.80392C3.97459 7.42557 8 8 8 8C8 8 3.97459 8.57443 2.35294 10.1961C0.731291 11.8177 0 16 0 16C0 16 -0.417564 11.8177 -2.03922 10.1961C-3.66087 8.57443 -8 8 -8 8C-8 8 -3.66087 7.42557 -2.03922 5.80392C-0.417564 4.18227 0 0 0 0Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_371_1181">
                                <rect width="8" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showNoUpdate && (
              <div className="feedback-modal-overlay fade-in">
                <div className="feedback-card reset">
                  <div className="avatar-circle-chat aimode">
                    <span className="bot-side-avatar aimode">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <rect
                          width="14"
                          height="14"
                          rx="7"
                          fill="white"
                          fill-opacity="0.7"
                        />
                        <path
                          opacity="0.5"
                          d="M7.22266 4.90039V7.2214L8.67315 8.67204"
                          stroke="#002449"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.51092 3.51106L3.08664 3.08682L3.08664 3.08682L3.51092 3.51106ZM2.77617 4.24588L2.17617 4.2489C2.17783 4.57791 2.44414 4.84422 2.77315 4.84587L2.77617 4.24588ZM4.25008 4.8533C4.58144 4.85496 4.85142 4.58769 4.85309 4.25632C4.85475 3.92495 4.58747 3.65498 4.25611 3.65331L4.25309 4.2533L4.25008 4.8533ZM3.36874 2.7658C3.36707 2.43444 3.0971 2.16716 2.76573 2.16882C2.43436 2.17049 2.16709 2.44047 2.16875 2.77183L2.76874 2.76882L3.36874 2.7658ZM2.64292 6.5396C2.68792 6.21129 2.45825 5.90868 2.12995 5.86368C1.80165 5.81869 1.49903 6.04835 1.45404 6.37665L2.04848 6.45812L2.64292 6.5396ZM10.8955 3.54817L11.3198 3.12393C9.04009 0.84397 5.35393 0.819312 3.08664 3.08682L3.51092 3.51106L3.9352 3.9353C5.72584 2.1445 8.6521 2.15308 10.4713 3.97242L10.8955 3.54817ZM3.54803 10.8964L3.12374 11.3206C5.40349 13.6006 9.08965 13.6252 11.3569 11.3577L10.9327 10.9335L10.5084 10.5092C8.71774 12.3 5.79148 12.2915 3.97231 10.4721L3.54803 10.8964ZM10.9327 10.9335L11.3569 11.3577C13.6242 9.09027 13.5995 5.40386 11.3198 3.12393L10.8955 3.54817L10.4713 3.97242C12.2905 5.79178 12.299 8.71842 10.5084 10.5092L10.9327 10.9335ZM3.51092 3.51106L3.08664 3.08682L2.35188 3.82164L2.77617 4.24588L3.20045 4.67013L3.9352 3.9353L3.51092 3.51106ZM2.77617 4.24588L2.77315 4.84587L4.25008 4.8533L4.25309 4.2533L4.25611 3.65331L2.77918 3.64589L2.77617 4.24588ZM2.77617 4.24588L3.37616 4.24287L3.36874 2.7658L2.76874 2.76882L2.16875 2.77183L2.17617 4.2489L2.77617 4.24588ZM2.04848 6.45812L1.45404 6.37665C1.21438 8.12527 1.77254 9.9693 3.12374 11.3206L3.54803 10.8964L3.97231 10.4721C2.89571 9.39544 2.45242 7.92956 2.64292 6.5396L2.04848 6.45812Z"
                          fill="#002449"
                        />
                      </svg>
                    </span>
                    <span className="head_text">Confirmation message</span>
                  </div>
                  <p className="feedback-subtitle reset">
                    No conversation to clear
                  </p>
                  <div className="feedback-actions reset">
                    <div className="cancel-stack">
                      <button
                        className="btn-cancel"
                        onClick={() => setShowNoUpdate(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="main-scroll-content">
              <div className="tab-pill-navigation" role="tablist">
                {categories.map((tab) => (
                  <>
                    <button role="tab" tabIndex="1"
                      className={` ${activeTab === tab ? "newtab active" : "newtab"}`}
                      key={tab}
                      onClick={() => {
                        setActiveTab(tab);
                        setShowLeavesFlow(false);
                        setApplyStep(0);
                        setInformation(tab === CommonObj.Question);
                        if (
                          (tab === CommonObj.PolicyName) &
                          (policymessages.length == 0)
                        ) {
                          PolicyInitialFun(input);
                        }
                      }}
                      style={{
                        color: activeTab === tab ? "#004a7c" : "#555",
                      }}
                    >
                      <span
                        className={` ${activeTab === tab ? "active" : ""}`}
                      ></span>
                      {tab}
                    </button>
                  </>
                ))}
              </div>

              <div
                className={` ${activeTab === CommonObj.Question ? "tab-content-render ask-queries-tab" : "tab-content-render"}`}
              >
                {activeTab === CommonObj.TransactionName && (
                  <div className="queries-container fade-in">
                    <div className="button-grid fade-in">
                      {transactionActions.map((action) => (
                        <button
                          key={action.id}
                          className={`grid-btn ${action.fullWidth ? "full-span" : ""}`}
                          onClick={() => {
                            handleSend(action.label);
                          }}
                        >
                          {action.label} <span className="chevron">›</span>
                        </button>
                      ))}
                    </div>
                    {/* {isLoading && (<div className="bot-msg-row">
                            <div className="bot-side-avatar">
                              <img src={chatavatr} alt="Bot" />
                            </div>
                            <div className="bot-bubble">
                              <div className="loader"></div>
                            </div>
                          </div>)
                  }*/}
                    {transactionmessages.map((msg, index) => (
                      <>
                        {msg.sender === "user" && (
                          <div className="fade-in">
                            <div className="user-msg-row">
                              <div className="user-reply-bubble clickable">
                                {parse(msg.text)}
                              </div>
                              <div className="user-tag-cw">{UserName}</div>
                            </div>
                          </div>
                        )}

                        {msg.sender === "bot" && (
                          <div className="fade-in">
                            <div className="bot-msg-row">
                              <div className="bot-side-avatar">
                                <img src={chatavatr} alt="Bot" />
                              </div>
                              <div className="bot-bubble">
                                <RenderHTML htmlContent={msg.text} />
                              </div>
                            </div>
                            <div className="feedback-icons-row">
                              <span
                                className={`feed-icon ${msg.isFeedback === "true" ? "liked" : ""}`}                               
                                onClick={() => {
                                  setResponseID(msg.responseId);
                                  setSelectedFeedback(null);
                                  setShowFeedbackModal(true);
                                  setIsSatifaction(true);
                                  //setCommentValidation(false);
                                  commentValidation = false;
                                  setFeedbackText("");
                                  SetFeedbackIndex(index);
                                }}
                              >
                                            {msg.isFeedback === "true" ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M13.513 10.8432L13.9833 8.12338C14.1008 7.44406 13.5784 6.82272 12.8897 6.82272H9.43566C9.09333 6.82272 8.83264 6.51544 8.88806 6.17724L9.32984 3.48087C9.40161 3.04282 9.38111 2.59459 9.26966 2.16494C9.17733 1.80901 8.90272 1.52322 8.54158 1.4072L8.44494 1.37615C8.22667 1.30604 7.98845 1.32235 7.78267 1.42151C7.55617 1.53066 7.39046 1.72974 7.32905 1.96651L7.01191 3.18908C6.911 3.57807 6.76402 3.95355 6.5745 4.30833C6.2976 4.8267 5.86948 5.24156 5.42446 5.62505L4.4653 6.45158C4.19486 6.68462 4.05284 7.03362 4.08361 7.38952L4.62505 13.6513C4.67472 14.2257 5.15492 14.6666 5.73077 14.6666H8.82985C11.1507 14.6666 13.1314 13.0495 13.513 10.8432Z" fill="#009DDB" />
                                                    <path d="M13.9833 8.12338L13.3921 8.02114V8.02114L13.9833 8.12338ZM13.513 10.8432L12.9217 10.741V10.741L13.513 10.8432ZM4.62505 13.6513L4.02728 13.703H4.02728L4.62505 13.6513ZM4.08361 7.38952L4.68138 7.33783V7.33783L4.08361 7.38952ZM9.32984 3.48087L9.92194 3.57788V3.57788L9.32984 3.48087ZM8.88806 6.17724L9.48016 6.27425V6.27425L8.88806 6.17724ZM4.4653 6.45158L4.07363 5.99705L4.07363 5.99705L4.4653 6.45158ZM5.42446 5.62505L5.81613 6.07957H5.81613L5.42446 5.62505ZM7.01191 3.18908L6.43113 3.03843V3.03843L7.01191 3.18908ZM7.32905 1.96651L7.90982 2.11717L7.90982 2.11717L7.32905 1.96651ZM8.44494 1.37615L8.26142 1.9474L8.26142 1.9474L8.44494 1.37615ZM8.54158 1.4072L8.72509 0.835955L8.72509 0.835955L8.54158 1.4072ZM6.5745 4.30833L7.10373 4.59103V4.59103L6.5745 4.30833ZM9.26966 2.16494L8.68888 2.31559V2.31559L9.26966 2.16494ZM7.78267 1.42151L7.52221 0.880996V0.880996L7.78267 1.42151ZM13.9833 8.12338L13.3921 8.02114L12.9217 10.741L13.513 10.8432L14.1042 10.9455L14.5745 8.22562L13.9833 8.12338ZM8.82985 14.6666V14.0666H5.73077V14.6666V15.2666H8.82985V14.6666ZM4.62505 13.6513L5.22282 13.5996L4.68138 7.33783L4.08361 7.38952L3.48584 7.44121L4.02728 13.703L4.62505 13.6513ZM13.513 10.8432L12.9217 10.741C12.5926 12.6442 10.8747 14.0666 8.82985 14.0666V14.6666V15.2666C11.4267 15.2666 13.6702 13.4548 14.1042 10.9455L13.513 10.8432ZM9.32984 3.48087L8.73773 3.38385L8.29595 6.08023L8.88806 6.17724L9.48016 6.27425L9.92194 3.57788L9.32984 3.48087ZM4.4653 6.45158L4.85697 6.9061L5.81613 6.07957L5.42446 5.62505L5.03278 5.17052L4.07363 5.99705L4.4653 6.45158ZM7.01191 3.18908L7.59269 3.33974L7.90982 2.11717L7.32905 1.96651L6.74827 1.81586L6.43113 3.03843L7.01191 3.18908ZM8.44494 1.37615L8.26142 1.9474L8.35807 1.97845L8.54158 1.4072L8.72509 0.835955L8.62845 0.804907L8.44494 1.37615ZM6.5745 4.30833L7.10373 4.59103C7.3154 4.19477 7.47978 3.775 7.59269 3.33974L7.01191 3.18908L6.43113 3.03843C6.34223 3.38114 6.21263 3.71233 6.04528 4.02563L6.5745 4.30833ZM8.54158 1.4072L8.35807 1.97845C8.53097 2.03399 8.65012 2.16617 8.68888 2.31559L9.26966 2.16494L9.85044 2.01428C9.70454 1.45185 9.27447 1.01244 8.72509 0.835955L8.54158 1.4072ZM7.32905 1.96651L7.90982 2.11717C7.92556 2.05652 7.97042 1.99707 8.04313 1.96203L7.78267 1.42151L7.52221 0.880996C7.14193 1.06425 6.85537 1.40297 6.74827 1.81586L7.32905 1.96651ZM7.78267 1.42151L8.04313 1.96203C8.10978 1.92992 8.18903 1.92415 8.26142 1.9474L8.44494 1.37615L8.62845 0.804908C8.26432 0.687931 7.86713 0.71479 7.52221 0.880996L7.78267 1.42151ZM9.43566 6.82272V7.42272H12.8897V6.82272V6.22272H9.43566V6.82272ZM9.32984 3.48087L9.92194 3.57788C10.0072 3.05739 9.98287 2.5248 9.85044 2.01428L9.26966 2.16494L8.68888 2.31559C8.77936 2.66437 8.796 3.02825 8.73773 3.38385L9.32984 3.48087ZM5.73077 14.6666V14.0666C5.46681 14.0666 5.24571 13.8644 5.22282 13.5996L4.62505 13.6513L4.02728 13.703C4.10372 14.587 4.84302 15.2666 5.73077 15.2666V14.6666ZM5.42446 5.62505L5.81613 6.07957C6.27101 5.68759 6.77165 5.2127 7.10373 4.59103L6.5745 4.30833L6.04528 4.02563C5.82356 4.4407 5.46795 4.79553 5.03278 5.17052L5.42446 5.62505ZM13.9833 8.12338L14.5745 8.22562C14.7553 7.1803 13.9514 6.22272 12.8897 6.22272V6.82272V7.42272C13.2053 7.42272 13.4463 7.70781 13.3921 8.02114L13.9833 8.12338ZM8.88806 6.17724L8.29595 6.08023C8.18083 6.78286 8.72243 7.42272 9.43566 7.42272V6.82272V6.22272C9.46423 6.22272 9.48446 6.24802 9.48016 6.27425L8.88806 6.17724ZM4.08361 7.38952L4.68138 7.33783C4.6672 7.17384 4.73267 7.01321 4.85697 6.9061L4.4653 6.45158L4.07363 5.99705C3.65705 6.35603 3.43847 6.89341 3.48584 7.44121L4.08361 7.38952Z" fill="#009DDB" />
                                                    <path d="M2.64773 14.314L2.04996 14.3657L2.04996 14.3657L2.64773 14.314ZM2 6.823L2.59777 6.77131C2.57009 6.45119 2.29514 6.2097 1.97413 6.22356C1.65312 6.23741 1.4 6.50169 1.4 6.823L2 6.823ZM2.64773 14.314L3.2455 14.2623L2.59777 6.77131L2 6.823L1.40223 6.87469L2.04996 14.3657L2.64773 14.314ZM2 14.342H2.6V6.823H2H1.4V14.342H2ZM2.64773 14.314L2.04996 14.3657C2.03613 14.2057 2.16222 14.0669 2.32447 14.0669V14.6669V15.2669C2.8672 15.2669 3.29215 14.8018 3.2455 14.2623L2.64773 14.314ZM2.32447 14.6669V14.0669C2.47728 14.0669 2.6 14.1907 2.6 14.342H2H1.4C1.4 14.8522 1.81326 15.2669 2.32447 15.2669V14.6669Z" fill="#204D92" />
                                                </svg>
                                            ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <rect
                                                            width="24"
                                                            height="24"
                                                            rx="12"
                                                            transform="matrix(-1 0 0 1 24 0)"
                                                            fill="#F5F5F5"
                                                        />
                                                        <path
                                                            d="M17.9832 12.1234L17.392 12.0211V12.0211L17.9832 12.1234ZM17.5128 14.8432L16.9216 14.741V14.741L17.5128 14.8432ZM8.62493 17.6513L8.02716 17.703H8.02716L8.62493 17.6513ZM8.08349 11.3895L8.68126 11.3378V11.3378L8.08349 11.3895ZM13.3297 7.48087L13.9218 7.57788V7.57788L13.3297 7.48087ZM12.8879 10.1772L13.48 10.2743V10.2743L12.8879 10.1772ZM8.46518 10.4516L8.0735 9.99705L8.0735 9.99705L8.46518 10.4516ZM9.42434 9.62505L9.81601 10.0796H9.81601L9.42434 9.62505ZM11.0118 7.18908L10.431 7.03843V7.03843L11.0118 7.18908ZM11.3289 5.96651L11.9097 6.11717L11.9097 6.11717L11.3289 5.96651ZM12.4448 5.37615L12.2613 5.9474L12.2613 5.9474L12.4448 5.37615ZM12.5415 5.4072L12.725 4.83596L12.725 4.83595L12.5415 5.4072ZM10.5744 8.30833L11.1036 8.59103V8.59103L10.5744 8.30833ZM13.2695 6.16494L12.6888 6.31559V6.31559L13.2695 6.16494ZM11.7825 5.42151L11.5221 4.881V4.881L11.7825 5.42151ZM17.9832 12.1234L17.392 12.0211L16.9216 14.741L17.5128 14.8432L18.1041 14.9455L18.5744 12.2256L17.9832 12.1234ZM12.8297 18.6666V18.0666H9.73065V18.6666V19.2666H12.8297V18.6666ZM8.62493 17.6513L9.2227 17.5996L8.68126 11.3378L8.08349 11.3895L7.48572 11.4412L8.02716 17.703L8.62493 17.6513ZM17.5128 14.8432L16.9216 14.741C16.5925 16.6442 14.8746 18.0666 12.8297 18.0666V18.6666V19.2666C15.4266 19.2666 17.6701 17.4548 18.1041 14.9455L17.5128 14.8432ZM13.3297 7.48087L12.7376 7.38385L12.2958 10.0802L12.8879 10.1772L13.48 10.2743L13.9218 7.57788L13.3297 7.48087ZM8.46518 10.4516L8.85685 10.9061L9.81601 10.0796L9.42434 9.62505L9.03266 9.17052L8.0735 9.99705L8.46518 10.4516ZM11.0118 7.18908L11.5926 7.33974L11.9097 6.11717L11.3289 5.96651L10.7481 5.81586L10.431 7.03843L11.0118 7.18908ZM12.4448 5.37615L12.2613 5.9474L12.3579 5.97845L12.5415 5.4072L12.725 4.83595L12.6283 4.80491L12.4448 5.37615ZM10.5744 8.30833L11.1036 8.59103C11.3153 8.19477 11.4797 7.775 11.5926 7.33974L11.0118 7.18908L10.431 7.03843C10.3421 7.38114 10.2125 7.71233 10.0452 8.02563L10.5744 8.30833ZM12.5415 5.4072L12.3579 5.97845C12.5309 6.03399 12.65 6.16617 12.6888 6.31559L13.2695 6.16494L13.8503 6.01428C13.7044 5.45185 13.2743 5.01244 12.725 4.83596L12.5415 5.4072ZM11.3289 5.96651L11.9097 6.11717C11.9254 6.05652 11.9703 5.99707 12.043 5.96203L11.7825 5.42151L11.5221 4.881C11.1418 5.06425 10.8553 5.40297 10.7481 5.81586L11.3289 5.96651ZM11.7825 5.42151L12.043 5.96203C12.1097 5.92992 12.1889 5.92415 12.2613 5.9474L12.4448 5.37615L12.6283 4.80491C12.2642 4.68793 11.867 4.71479 11.5221 4.881L11.7825 5.42151ZM13.4355 10.8227V11.4227H16.8896V10.8227V10.2227H13.4355V10.8227ZM13.3297 7.48087L13.9218 7.57788C14.0071 7.05739 13.9827 6.5248 13.8503 6.01428L13.2695 6.16494L12.6888 6.31559C12.7792 6.66437 12.7959 7.02825 12.7376 7.38385L13.3297 7.48087ZM9.73065 18.6666V18.0666C9.46669 18.0666 9.24559 17.8644 9.2227 17.5996L8.62493 17.6513L8.02716 17.703C8.1036 18.587 8.8429 19.2666 9.73065 19.2666V18.6666ZM9.42434 9.62505L9.81601 10.0796C10.2709 9.68759 10.7715 9.2127 11.1036 8.59103L10.5744 8.30833L10.0452 8.02563C9.82344 8.4407 9.46783 8.79553 9.03266 9.17052L9.42434 9.62505ZM17.9832 12.1234L18.5744 12.2256C18.7552 11.1803 17.9513 10.2227 16.8896 10.2227V10.8227V11.4227C17.2052 11.4227 17.4461 11.7078 17.392 12.0211L17.9832 12.1234ZM12.8879 10.1772L12.2958 10.0802C12.1807 10.7829 12.7223 11.4227 13.4355 11.4227V10.8227V10.2227C13.4641 10.2227 13.4843 10.248 13.48 10.2743L12.8879 10.1772ZM8.08349 11.3895L8.68126 11.3378C8.66708 11.1738 8.73255 11.0132 8.85685 10.9061L8.46518 10.4516L8.0735 9.99705C7.65693 10.356 7.43835 10.8934 7.48572 11.4412L8.08349 11.3895Z"
                                                            fill="#002449"
                                                        />
                                                        <path
                                                            opacity="0.5"
                                                            d="M6.64773 18.314L6.04996 18.3657L6.04996 18.3657L6.64773 18.314ZM6 10.823L6.59777 10.7713C6.57009 10.4512 6.29514 10.2097 5.97413 10.2236C5.65312 10.2374 5.4 10.5017 5.4 10.823H6ZM6.64773 18.314L7.2455 18.2623L6.59777 10.7713L6 10.823L5.40223 10.8747L6.04996 18.3657L6.64773 18.314ZM6 18.342H6.6V10.823H6H5.4V18.342H6ZM6.64773 18.314L6.04996 18.3657C6.03613 18.2057 6.16222 18.0669 6.32447 18.0669V18.6669V19.2669C6.8672 19.2669 7.29215 18.8018 7.2455 18.2623L6.64773 18.314ZM6.32447 18.6669V18.0669C6.47728 18.0669 6.6 18.1907 6.6 18.342H6H5.4C5.4 18.8522 5.81326 19.2669 6.32447 19.2669V18.6669Z"
                                                            fill="#002449"
                                                        />
                                                    </svg>
                                            )}
                                
                              </span>
                              <span
                               className={`feed-icon ${msg.isFeedback === "false" ? "disliked" : ""}`}  
                                onClick={() => {
                                  setResponseID(msg.responseId);
                                  setSelectedFeedback(null);
                                  setShowFeedbackModal(true);
                                  setIsSatifaction(false);
                                  //setCommentValidation(false);
                                  commentValidation = false;
                                  setFeedbackText("");
                                  SetFeedbackIndex(index);
                                }}
                              >
                                            {msg.isFeedback === "false" ? (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M13.513 5.15678L13.9833 7.87662C14.1008 8.55594 13.5784 9.17728 12.8897 9.17728H9.43566C9.09333 9.17728 8.83264 9.48456 8.88806 9.82276L9.32984 12.5191C9.40161 12.9572 9.38111 13.4054 9.26966 13.8351C9.17733 14.191 8.90272 14.4768 8.54158 14.5928L8.44493 14.6238C8.22667 14.694 7.98845 14.6776 7.78267 14.5785C7.55617 14.4693 7.39046 14.2703 7.32905 14.0335L7.01191 12.8109C6.911 12.4219 6.76402 12.0464 6.5745 11.6917C6.2976 11.1733 5.86948 10.7584 5.42446 10.375L4.4653 9.54842C4.19486 9.31538 4.05284 8.96638 4.08361 8.61048L4.62505 2.3487C4.67472 1.77434 5.15492 1.33341 5.73077 1.33341H8.82985C11.1507 1.33341 13.1314 2.95049 13.513 5.15678Z" fill="#CE0016" />
                                                <path d="M13.9833 7.87662L13.3921 7.97886V7.97886L13.9833 7.87662ZM13.513 5.15678L12.9217 5.25902V5.25902L13.513 5.15678ZM4.62505 2.3487L4.02728 2.29701H4.02728L4.62505 2.3487ZM4.08361 8.61048L4.68138 8.66217V8.66217L4.08361 8.61048ZM9.32984 12.5191L9.92194 12.4221V12.4221L9.32984 12.5191ZM8.88806 9.82276L9.48016 9.72575V9.72575L8.88806 9.82276ZM4.4653 9.54842L4.07363 10.0029H4.07363L4.4653 9.54842ZM5.42446 10.375L5.81613 9.92043H5.81613L5.42446 10.375ZM7.01191 12.8109L6.43113 12.9616V12.9616L7.01191 12.8109ZM7.32905 14.0335L7.90982 13.8828L7.90982 13.8828L7.32905 14.0335ZM8.44493 14.6238L8.26142 14.0526L8.26142 14.0526L8.44493 14.6238ZM8.54158 14.5928L8.72509 15.164L8.72509 15.164L8.54158 14.5928ZM6.5745 11.6917L7.10373 11.409L7.10373 11.409L6.5745 11.6917ZM9.26966 13.8351L8.68888 13.6844V13.6844L9.26966 13.8351ZM7.78267 14.5785L7.52221 15.119L7.52221 15.119L7.78267 14.5785ZM13.9833 7.87662L13.3921 7.97886L12.9217 5.25902L13.513 5.15678L14.1042 5.05454L14.5745 7.77438L13.9833 7.87662ZM8.82985 1.33341V1.93341H5.73077V1.33341V0.733415H8.82985V1.33341ZM4.62505 2.3487L5.22282 2.40039L4.68138 8.66217L4.08361 8.61048L3.48584 8.55879L4.02728 2.29701L4.62505 2.3487ZM13.513 5.15678L12.9217 5.25902C12.5926 3.35581 10.8747 1.93341 8.82985 1.93341V1.33341V0.733415C11.4267 0.733415 13.6702 2.54516 14.1042 5.05454L13.513 5.15678ZM9.32984 12.5191L8.73773 12.6161L8.29595 9.91977L8.88806 9.82276L9.48016 9.72575L9.92194 12.4221L9.32984 12.5191ZM4.4653 9.54842L4.85697 9.0939L5.81613 9.92043L5.42446 10.375L5.03278 10.8295L4.07363 10.0029L4.4653 9.54842ZM7.01191 12.8109L7.59268 12.6603L7.90982 13.8828L7.32905 14.0335L6.74827 14.1841L6.43113 12.9616L7.01191 12.8109ZM8.44493 14.6238L8.26142 14.0526L8.35807 14.0216L8.54158 14.5928L8.72509 15.164L8.62845 15.1951L8.44493 14.6238ZM6.5745 11.6917L7.10373 11.409C7.3154 11.8052 7.47978 12.225 7.59268 12.6603L7.01191 12.8109L6.43113 12.9616C6.34223 12.6189 6.21263 12.2877 6.04528 11.9744L6.5745 11.6917ZM8.54158 14.5928L8.35807 14.0216C8.53097 13.966 8.65012 13.8338 8.68888 13.6844L9.26966 13.8351L9.85044 13.9857C9.70454 14.5481 9.27447 14.9876 8.72509 15.164L8.54158 14.5928ZM7.32905 14.0335L7.90982 13.8828C7.92556 13.9435 7.97042 14.0029 8.04313 14.038L7.78267 14.5785L7.52221 15.119C7.14193 14.9358 6.85537 14.597 6.74827 14.1841L7.32905 14.0335ZM7.78267 14.5785L8.04313 14.038C8.10977 14.0701 8.18903 14.0759 8.26142 14.0526L8.44493 14.6238L8.62845 15.1951C8.26432 15.3121 7.86713 15.2852 7.52221 15.119L7.78267 14.5785ZM9.43566 9.17728V8.57728H12.8897V9.17728V9.77728H9.43566V9.17728ZM9.32984 12.5191L9.92194 12.4221C10.0072 12.9426 9.98287 13.4752 9.85044 13.9857L9.26966 13.8351L8.68888 13.6844C8.77936 13.3356 8.796 12.9718 8.73773 12.6161L9.32984 12.5191ZM5.73077 1.33341V1.93341C5.46681 1.93341 5.24571 2.13565 5.22282 2.40039L4.62505 2.3487L4.02728 2.29701C4.10372 1.41303 4.84302 0.733415 5.73077 0.733415V1.33341ZM5.42446 10.375L5.81613 9.92043C6.27101 10.3124 6.77165 10.7873 7.10373 11.409L6.5745 11.6917L6.04528 11.9744C5.82356 11.5593 5.46795 11.2045 5.03278 10.8295L5.42446 10.375ZM13.9833 7.87662L14.5745 7.77438C14.7553 8.8197 13.9514 9.77728 12.8897 9.77728V9.17728V8.57728C13.2053 8.57728 13.4463 8.29219 13.3921 7.97886L13.9833 7.87662ZM8.88806 9.82276L8.29595 9.91977C8.18083 9.21714 8.72243 8.57728 9.43566 8.57728V9.17728V9.77728C9.46423 9.77728 9.48446 9.75198 9.48016 9.72575L8.88806 9.82276ZM4.08361 8.61048L4.68138 8.66217C4.6672 8.82616 4.73267 8.98679 4.85697 9.0939L4.4653 9.54842L4.07363 10.0029C3.65705 9.64397 3.43847 9.10659 3.48584 8.55879L4.08361 8.61048Z" fill="#CE0016" />
                                                <path opacity="0.5" d="M2.64773 1.68599L2.04996 1.6343H2.04996L2.64773 1.68599ZM2 9.177L2.59777 9.22869C2.57009 9.54881 2.29514 9.7903 1.97413 9.77644C1.65312 9.76259 1.4 9.49831 1.4 9.177H2ZM2.64773 1.68599L3.2455 1.73768L2.59777 9.22869L2 9.177L1.40223 9.12531L2.04996 1.6343L2.64773 1.68599ZM2 1.65798H2.6V9.177H2H1.4V1.65798H2ZM2.64773 1.68599L2.04996 1.6343C2.03613 1.79429 2.16222 1.93314 2.32447 1.93314V1.33314V0.733136C2.8672 0.733136 3.29215 1.19819 3.2455 1.73768L2.64773 1.68599ZM2.32447 1.33314V1.93314C2.47728 1.93314 2.6 1.8093 2.6 1.65798H2H1.4C1.4 1.14784 1.81326 0.733136 2.32447 0.733136V1.33314Z" fill="#CE0016" />
                                            </svg>): (<svg
                                  xmlns = "http://www.w3.org/2000/svg"
                                  width = "24"
                                  height = "24"
                                  viewBox = "0 0 24 24"
                                  fill = "none"
                                            >
                                  <rect
                                    width = "24"
                                    height = "24"
                                    rx = "12"
                                    transform = "matrix(-1 0 0 1 24 0)"
                                    fill = "#F5F5F5"
                                  />
                                            <path
                                                d="M17.9832 11.8766L17.392 11.9789V11.9789L17.9832 11.8766ZM17.5128 9.15678L16.9216 9.25902V9.25902L17.5128 9.15678ZM8.62493 6.3487L8.02716 6.29701H8.02716L8.62493 6.3487ZM8.08349 12.6105L8.68126 12.6622V12.6622L8.08349 12.6105ZM13.3297 16.5191L13.9218 16.4221V16.4221L13.3297 16.5191ZM12.8879 13.8228L13.48 13.7257V13.7257L12.8879 13.8228ZM8.46518 13.5484L8.0735 14.0029H8.0735L8.46518 13.5484ZM9.42434 14.375L9.81601 13.9204H9.81601L9.42434 14.375ZM11.0118 16.8109L10.431 16.9616V16.9616L11.0118 16.8109ZM11.3289 18.0335L11.9097 17.8828L11.9097 17.8828L11.3289 18.0335ZM12.4448 18.6238L12.2613 18.0526L12.2613 18.0526L12.4448 18.6238ZM12.5415 18.5928L12.725 19.164L12.725 19.164L12.5415 18.5928ZM10.5744 15.6917L11.1036 15.409L11.1036 15.409L10.5744 15.6917ZM13.2695 17.8351L12.6888 17.6844V17.6844L13.2695 17.8351ZM11.7825 18.5785L11.5221 19.119L11.5221 19.119L11.7825 18.5785ZM17.9832 11.8766L17.392 11.9789L16.9216 9.25902L17.5128 9.15678L18.1041 9.05454L18.5744 11.7744L17.9832 11.8766ZM12.8297 5.33341V5.93341H9.73065V5.33341V4.73341H12.8297V5.33341ZM8.62493 6.3487L9.2227 6.40039L8.68126 12.6622L8.08349 12.6105L7.48572 12.5588L8.02716 6.29701L8.62493 6.3487ZM17.5128 9.15678L16.9216 9.25902C16.5925 7.35581 14.8746 5.93341 12.8297 5.93341V5.33341V4.73341C15.4266 4.73341 17.6701 6.54516 18.1041 9.05454L17.5128 9.15678ZM13.3297 16.5191L12.7376 16.6161L12.2958 13.9198L12.8879 13.8228L13.48 13.7257L13.9218 16.4221L13.3297 16.5191ZM8.46518 13.5484L8.85685 13.0939L9.81601 13.9204L9.42434 14.375L9.03266 14.8295L8.0735 14.0029L8.46518 13.5484ZM11.0118 16.8109L11.5926 16.6603L11.9097 17.8828L11.3289 18.0335L10.7481 18.1841L10.431 16.9616L11.0118 16.8109ZM12.4448 18.6238L12.2613 18.0526L12.3579 18.0216L12.5415 18.5928L12.725 19.164L12.6283 19.1951L12.4448 18.6238ZM10.5744 15.6917L11.1036 15.409C11.3153 15.8052 11.4797 16.225 11.5926 16.6603L11.0118 16.8109L10.431 16.9616C10.3421 16.6189 10.2125 16.2877 10.0452 15.9744L10.5744 15.6917ZM12.5415 18.5928L12.3579 18.0216C12.5309 17.966 12.65 17.8338 12.6888 17.6844L13.2695 17.8351L13.8503 17.9857C13.7044 18.5481 13.2743 18.9876 12.725 19.164L12.5415 18.5928ZM11.3289 18.0335L11.9097 17.8828C11.9254 17.9435 11.9703 18.0029 12.043 18.038L11.7825 18.5785L11.5221 19.119C11.1418 18.9358 10.8553 18.597 10.7481 18.1841L11.3289 18.0335ZM11.7825 18.5785L12.043 18.038C12.1097 18.0701 12.1889 18.0759 12.2613 18.0526L12.4448 18.6238L12.6283 19.1951C12.2642 19.3121 11.867 19.2852 11.5221 19.119L11.7825 18.5785ZM13.4355 13.1773V12.5773H16.8896V13.1773V13.7773H13.4355V13.1773ZM13.3297 16.5191L13.9218 16.4221C14.0071 16.9426 13.9827 17.4752 13.8503 17.9857L13.2695 17.8351L12.6888 17.6844C12.7792 17.3356 12.7959 16.9718 12.7376 16.6161L13.3297 16.5191ZM9.73065 5.33341V5.93341C9.46669 5.93341 9.24559 6.13565 9.2227 6.40039L8.62493 6.3487L8.02716 6.29701C8.1036 5.41303 8.8429 4.73341 9.73065 4.73341V5.33341ZM9.42434 14.375L9.81601 13.9204C10.2709 14.3124 10.7715 14.7873 11.1036 15.409L10.5744 15.6917L10.0452 15.9744C9.82344 15.5593 9.46783 15.2045 9.03266 14.8295L9.42434 14.375ZM17.9832 11.8766L18.5744 11.7744C18.7552 12.8197 17.9513 13.7773 16.8896 13.7773V13.1773V12.5773C17.2052 12.5773 17.4461 12.2922 17.392 11.9789L17.9832 11.8766ZM12.8879 13.8228L12.2958 13.9198C12.1807 13.2171 12.7223 12.5773 13.4355 12.5773V13.1773V13.7773C13.4641 13.7773 13.4843 13.752 13.48 13.7257L12.8879 13.8228ZM8.08349 12.6105L8.68126 12.6622C8.66708 12.8262 8.73255 12.9868 8.85685 13.0939L8.46518 13.5484L8.0735 14.0029C7.65693 13.644 7.43835 13.1066 7.48572 12.5588L8.08349 12.6105Z"
                                                fill="#002449"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M6.64773 5.68599L6.04996 5.6343H6.04996L6.64773 5.68599ZM6 13.177L6.59777 13.2287C6.57009 13.5488 6.29514 13.7903 5.97413 13.7764C5.65312 13.7626 5.4 13.4983 5.4 13.177H6ZM6.64773 5.68599L7.2455 5.73768L6.59777 13.2287L6 13.177L5.40223 13.1253L6.04996 5.6343L6.64773 5.68599ZM6 5.65798H6.6V13.177H6H5.4V5.65798H6ZM6.64773 5.68599L6.04996 5.6343C6.03613 5.79429 6.16222 5.93314 6.32447 5.93314V5.33314V4.73314C6.8672 4.73314 7.29215 5.19819 7.2455 5.73768L6.64773 5.68599ZM6.32447 5.33314V5.93314C6.47728 5.93314 6.6 5.8093 6.6 5.65798H6H5.4C5.4 5.14784 5.81326 4.73314 6.32447 4.73314V5.33314Z"
                                                fill="#002449"
                                            />
                                        </svg>)}
                                
                                
                              </span>
                              {/* <span className="feed-icon reset-orange" onClick={resetChat}>↪️</span> */}
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                )}
                {activeTab === CommonObj.Question && (
                  <div className="queries-container fade-in">
                    { querymessages.length ==0 ? <div className="welcome-chat"> <img src={placeholder} alt="Ask a Question"></img> 
                    <p>Hello! I'm Amigo, your Policy Assistant.</p>
                     <p> How can I help today?</p>
                    </div> : <></>
                    }
                    {querymessages.map((msg, index) => (
                      <>
                        {msg.sender === "user" && (
                          <div className="fade-in">
                            <div className="user-msg-row">
                              <div className="user-reply-bubble clickable">
                                {msg.text}
                              </div>
                              <div className="user-tag-cw">{UserName}</div>
                            </div>
                          </div>
                        )}

                        {msg.sender === "bot" && (
                          <div className="fade-in">
                            <div className="bot-msg-row">
                              <div className="bot-side-avatar">
                                <img src={chatavatr} alt="Bot" />
                              </div>
                              {msg.text ? (
                                <div className="bot-bubble">
                                  {/<[a-z][\s\S]*>/i.test(msg.text) ? (
                                    <RenderHTML htmlContent={msg.text} />
                                  ) : (
                                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{msg.text}</ReactMarkdown>
                                  )}

                                 {msg.documents ? msg.documents.map((ref, refindex) => (
  <React.Fragment key={refindex}>
    <br />
    <p>Source : {ref.source}</p>
    <p>Page No : &nbsp;
      {ref.pages?.map(p => p).join(', ') || 'N/A'}
    </p>
  </React.Fragment>
)) : null}
                                </div>
                              ) : (
                                <>
                                  <div className="bot-bubble">
                                    <span>
                                      I'm sorry, I couldn't find a clear answer to your query in the available policies. 
                                      If you're looking for {" "}
                                      <b>GDC policies</b>,                                      
                                      please refer to the {" "}
                                      
                                       <b style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        color: "blue",
                                      }}
                                      onClick={openDefaultPolicies}
                                    > Policies and References </b> section.
                                      For further assistance, you can reach out to the HR team at <b>{policymailid}</b> or connect with your manager. 
                                      If you're looking for {" "}<b>RRD Global Policies</b>, 
                                      please visit {" "}
                                      </span>
                                     <b
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        color: "blue",
                                      }}
                                      onClick={openDiscoverPolicies}
                                    >
                                     Discover RRD.
                                    </b>
                                  </div>
                                  ,
                                </>
                              )}
                            </div>
                            <div className="feedback-icons-row">
                              <span
                               className={`feed-icon ${msg.isFeedback === "true" ? "liked" : ""}`}  
                                onClick={() => {
                                  setResponseID(msg.responseId);
                                  setSelectedFeedback(null);
                                  setShowFeedbackModal(true);
                                  setIsSatifaction(true);
                                  //setCommentValidation(false);
                                  commentValidation = false;
                                  setFeedbackText("");
                                   SetFeedbackIndex(index);
                                }}
                              >
                               {msg.isFeedback === "true" ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M13.513 10.8432L13.9833 8.12338C14.1008 7.44406 13.5784 6.82272 12.8897 6.82272H9.43566C9.09333 6.82272 8.83264 6.51544 8.88806 6.17724L9.32984 3.48087C9.40161 3.04282 9.38111 2.59459 9.26966 2.16494C9.17733 1.80901 8.90272 1.52322 8.54158 1.4072L8.44494 1.37615C8.22667 1.30604 7.98845 1.32235 7.78267 1.42151C7.55617 1.53066 7.39046 1.72974 7.32905 1.96651L7.01191 3.18908C6.911 3.57807 6.76402 3.95355 6.5745 4.30833C6.2976 4.8267 5.86948 5.24156 5.42446 5.62505L4.4653 6.45158C4.19486 6.68462 4.05284 7.03362 4.08361 7.38952L4.62505 13.6513C4.67472 14.2257 5.15492 14.6666 5.73077 14.6666H8.82985C11.1507 14.6666 13.1314 13.0495 13.513 10.8432Z" fill="#009DDB" />
                                                    <path d="M13.9833 8.12338L13.3921 8.02114V8.02114L13.9833 8.12338ZM13.513 10.8432L12.9217 10.741V10.741L13.513 10.8432ZM4.62505 13.6513L4.02728 13.703H4.02728L4.62505 13.6513ZM4.08361 7.38952L4.68138 7.33783V7.33783L4.08361 7.38952ZM9.32984 3.48087L9.92194 3.57788V3.57788L9.32984 3.48087ZM8.88806 6.17724L9.48016 6.27425V6.27425L8.88806 6.17724ZM4.4653 6.45158L4.07363 5.99705L4.07363 5.99705L4.4653 6.45158ZM5.42446 5.62505L5.81613 6.07957H5.81613L5.42446 5.62505ZM7.01191 3.18908L6.43113 3.03843V3.03843L7.01191 3.18908ZM7.32905 1.96651L7.90982 2.11717L7.90982 2.11717L7.32905 1.96651ZM8.44494 1.37615L8.26142 1.9474L8.26142 1.9474L8.44494 1.37615ZM8.54158 1.4072L8.72509 0.835955L8.72509 0.835955L8.54158 1.4072ZM6.5745 4.30833L7.10373 4.59103V4.59103L6.5745 4.30833ZM9.26966 2.16494L8.68888 2.31559V2.31559L9.26966 2.16494ZM7.78267 1.42151L7.52221 0.880996V0.880996L7.78267 1.42151ZM13.9833 8.12338L13.3921 8.02114L12.9217 10.741L13.513 10.8432L14.1042 10.9455L14.5745 8.22562L13.9833 8.12338ZM8.82985 14.6666V14.0666H5.73077V14.6666V15.2666H8.82985V14.6666ZM4.62505 13.6513L5.22282 13.5996L4.68138 7.33783L4.08361 7.38952L3.48584 7.44121L4.02728 13.703L4.62505 13.6513ZM13.513 10.8432L12.9217 10.741C12.5926 12.6442 10.8747 14.0666 8.82985 14.0666V14.6666V15.2666C11.4267 15.2666 13.6702 13.4548 14.1042 10.9455L13.513 10.8432ZM9.32984 3.48087L8.73773 3.38385L8.29595 6.08023L8.88806 6.17724L9.48016 6.27425L9.92194 3.57788L9.32984 3.48087ZM4.4653 6.45158L4.85697 6.9061L5.81613 6.07957L5.42446 5.62505L5.03278 5.17052L4.07363 5.99705L4.4653 6.45158ZM7.01191 3.18908L7.59269 3.33974L7.90982 2.11717L7.32905 1.96651L6.74827 1.81586L6.43113 3.03843L7.01191 3.18908ZM8.44494 1.37615L8.26142 1.9474L8.35807 1.97845L8.54158 1.4072L8.72509 0.835955L8.62845 0.804907L8.44494 1.37615ZM6.5745 4.30833L7.10373 4.59103C7.3154 4.19477 7.47978 3.775 7.59269 3.33974L7.01191 3.18908L6.43113 3.03843C6.34223 3.38114 6.21263 3.71233 6.04528 4.02563L6.5745 4.30833ZM8.54158 1.4072L8.35807 1.97845C8.53097 2.03399 8.65012 2.16617 8.68888 2.31559L9.26966 2.16494L9.85044 2.01428C9.70454 1.45185 9.27447 1.01244 8.72509 0.835955L8.54158 1.4072ZM7.32905 1.96651L7.90982 2.11717C7.92556 2.05652 7.97042 1.99707 8.04313 1.96203L7.78267 1.42151L7.52221 0.880996C7.14193 1.06425 6.85537 1.40297 6.74827 1.81586L7.32905 1.96651ZM7.78267 1.42151L8.04313 1.96203C8.10978 1.92992 8.18903 1.92415 8.26142 1.9474L8.44494 1.37615L8.62845 0.804908C8.26432 0.687931 7.86713 0.71479 7.52221 0.880996L7.78267 1.42151ZM9.43566 6.82272V7.42272H12.8897V6.82272V6.22272H9.43566V6.82272ZM9.32984 3.48087L9.92194 3.57788C10.0072 3.05739 9.98287 2.5248 9.85044 2.01428L9.26966 2.16494L8.68888 2.31559C8.77936 2.66437 8.796 3.02825 8.73773 3.38385L9.32984 3.48087ZM5.73077 14.6666V14.0666C5.46681 14.0666 5.24571 13.8644 5.22282 13.5996L4.62505 13.6513L4.02728 13.703C4.10372 14.587 4.84302 15.2666 5.73077 15.2666V14.6666ZM5.42446 5.62505L5.81613 6.07957C6.27101 5.68759 6.77165 5.2127 7.10373 4.59103L6.5745 4.30833L6.04528 4.02563C5.82356 4.4407 5.46795 4.79553 5.03278 5.17052L5.42446 5.62505ZM13.9833 8.12338L14.5745 8.22562C14.7553 7.1803 13.9514 6.22272 12.8897 6.22272V6.82272V7.42272C13.2053 7.42272 13.4463 7.70781 13.3921 8.02114L13.9833 8.12338ZM8.88806 6.17724L8.29595 6.08023C8.18083 6.78286 8.72243 7.42272 9.43566 7.42272V6.82272V6.22272C9.46423 6.22272 9.48446 6.24802 9.48016 6.27425L8.88806 6.17724ZM4.08361 7.38952L4.68138 7.33783C4.6672 7.17384 4.73267 7.01321 4.85697 6.9061L4.4653 6.45158L4.07363 5.99705C3.65705 6.35603 3.43847 6.89341 3.48584 7.44121L4.08361 7.38952Z" fill="#009DDB" />
                                                    <path d="M2.64773 14.314L2.04996 14.3657L2.04996 14.3657L2.64773 14.314ZM2 6.823L2.59777 6.77131C2.57009 6.45119 2.29514 6.2097 1.97413 6.22356C1.65312 6.23741 1.4 6.50169 1.4 6.823L2 6.823ZM2.64773 14.314L3.2455 14.2623L2.59777 6.77131L2 6.823L1.40223 6.87469L2.04996 14.3657L2.64773 14.314ZM2 14.342H2.6V6.823H2H1.4V14.342H2ZM2.64773 14.314L2.04996 14.3657C2.03613 14.2057 2.16222 14.0669 2.32447 14.0669V14.6669V15.2669C2.8672 15.2669 3.29215 14.8018 3.2455 14.2623L2.64773 14.314ZM2.32447 14.6669V14.0669C2.47728 14.0669 2.6 14.1907 2.6 14.342H2H1.4C1.4 14.8522 1.81326 15.2669 2.32447 15.2669V14.6669Z" fill="#204D92" />
                                                </svg>
                                            ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <rect
                                                            width="24"
                                                            height="24"
                                                            rx="12"
                                                            transform="matrix(-1 0 0 1 24 0)"
                                                            fill="#F5F5F5"
                                                        />
                                                        <path
                                                            d="M17.9832 12.1234L17.392 12.0211V12.0211L17.9832 12.1234ZM17.5128 14.8432L16.9216 14.741V14.741L17.5128 14.8432ZM8.62493 17.6513L8.02716 17.703H8.02716L8.62493 17.6513ZM8.08349 11.3895L8.68126 11.3378V11.3378L8.08349 11.3895ZM13.3297 7.48087L13.9218 7.57788V7.57788L13.3297 7.48087ZM12.8879 10.1772L13.48 10.2743V10.2743L12.8879 10.1772ZM8.46518 10.4516L8.0735 9.99705L8.0735 9.99705L8.46518 10.4516ZM9.42434 9.62505L9.81601 10.0796H9.81601L9.42434 9.62505ZM11.0118 7.18908L10.431 7.03843V7.03843L11.0118 7.18908ZM11.3289 5.96651L11.9097 6.11717L11.9097 6.11717L11.3289 5.96651ZM12.4448 5.37615L12.2613 5.9474L12.2613 5.9474L12.4448 5.37615ZM12.5415 5.4072L12.725 4.83596L12.725 4.83595L12.5415 5.4072ZM10.5744 8.30833L11.1036 8.59103V8.59103L10.5744 8.30833ZM13.2695 6.16494L12.6888 6.31559V6.31559L13.2695 6.16494ZM11.7825 5.42151L11.5221 4.881V4.881L11.7825 5.42151ZM17.9832 12.1234L17.392 12.0211L16.9216 14.741L17.5128 14.8432L18.1041 14.9455L18.5744 12.2256L17.9832 12.1234ZM12.8297 18.6666V18.0666H9.73065V18.6666V19.2666H12.8297V18.6666ZM8.62493 17.6513L9.2227 17.5996L8.68126 11.3378L8.08349 11.3895L7.48572 11.4412L8.02716 17.703L8.62493 17.6513ZM17.5128 14.8432L16.9216 14.741C16.5925 16.6442 14.8746 18.0666 12.8297 18.0666V18.6666V19.2666C15.4266 19.2666 17.6701 17.4548 18.1041 14.9455L17.5128 14.8432ZM13.3297 7.48087L12.7376 7.38385L12.2958 10.0802L12.8879 10.1772L13.48 10.2743L13.9218 7.57788L13.3297 7.48087ZM8.46518 10.4516L8.85685 10.9061L9.81601 10.0796L9.42434 9.62505L9.03266 9.17052L8.0735 9.99705L8.46518 10.4516ZM11.0118 7.18908L11.5926 7.33974L11.9097 6.11717L11.3289 5.96651L10.7481 5.81586L10.431 7.03843L11.0118 7.18908ZM12.4448 5.37615L12.2613 5.9474L12.3579 5.97845L12.5415 5.4072L12.725 4.83595L12.6283 4.80491L12.4448 5.37615ZM10.5744 8.30833L11.1036 8.59103C11.3153 8.19477 11.4797 7.775 11.5926 7.33974L11.0118 7.18908L10.431 7.03843C10.3421 7.38114 10.2125 7.71233 10.0452 8.02563L10.5744 8.30833ZM12.5415 5.4072L12.3579 5.97845C12.5309 6.03399 12.65 6.16617 12.6888 6.31559L13.2695 6.16494L13.8503 6.01428C13.7044 5.45185 13.2743 5.01244 12.725 4.83596L12.5415 5.4072ZM11.3289 5.96651L11.9097 6.11717C11.9254 6.05652 11.9703 5.99707 12.043 5.96203L11.7825 5.42151L11.5221 4.881C11.1418 5.06425 10.8553 5.40297 10.7481 5.81586L11.3289 5.96651ZM11.7825 5.42151L12.043 5.96203C12.1097 5.92992 12.1889 5.92415 12.2613 5.9474L12.4448 5.37615L12.6283 4.80491C12.2642 4.68793 11.867 4.71479 11.5221 4.881L11.7825 5.42151ZM13.4355 10.8227V11.4227H16.8896V10.8227V10.2227H13.4355V10.8227ZM13.3297 7.48087L13.9218 7.57788C14.0071 7.05739 13.9827 6.5248 13.8503 6.01428L13.2695 6.16494L12.6888 6.31559C12.7792 6.66437 12.7959 7.02825 12.7376 7.38385L13.3297 7.48087ZM9.73065 18.6666V18.0666C9.46669 18.0666 9.24559 17.8644 9.2227 17.5996L8.62493 17.6513L8.02716 17.703C8.1036 18.587 8.8429 19.2666 9.73065 19.2666V18.6666ZM9.42434 9.62505L9.81601 10.0796C10.2709 9.68759 10.7715 9.2127 11.1036 8.59103L10.5744 8.30833L10.0452 8.02563C9.82344 8.4407 9.46783 8.79553 9.03266 9.17052L9.42434 9.62505ZM17.9832 12.1234L18.5744 12.2256C18.7552 11.1803 17.9513 10.2227 16.8896 10.2227V10.8227V11.4227C17.2052 11.4227 17.4461 11.7078 17.392 12.0211L17.9832 12.1234ZM12.8879 10.1772L12.2958 10.0802C12.1807 10.7829 12.7223 11.4227 13.4355 11.4227V10.8227V10.2227C13.4641 10.2227 13.4843 10.248 13.48 10.2743L12.8879 10.1772ZM8.08349 11.3895L8.68126 11.3378C8.66708 11.1738 8.73255 11.0132 8.85685 10.9061L8.46518 10.4516L8.0735 9.99705C7.65693 10.356 7.43835 10.8934 7.48572 11.4412L8.08349 11.3895Z"
                                                            fill="#002449"
                                                        />
                                                        <path
                                                            opacity="0.5"
                                                            d="M6.64773 18.314L6.04996 18.3657L6.04996 18.3657L6.64773 18.314ZM6 10.823L6.59777 10.7713C6.57009 10.4512 6.29514 10.2097 5.97413 10.2236C5.65312 10.2374 5.4 10.5017 5.4 10.823H6ZM6.64773 18.314L7.2455 18.2623L6.59777 10.7713L6 10.823L5.40223 10.8747L6.04996 18.3657L6.64773 18.314ZM6 18.342H6.6V10.823H6H5.4V18.342H6ZM6.64773 18.314L6.04996 18.3657C6.03613 18.2057 6.16222 18.0669 6.32447 18.0669V18.6669V19.2669C6.8672 19.2669 7.29215 18.8018 7.2455 18.2623L6.64773 18.314ZM6.32447 18.6669V18.0669C6.47728 18.0669 6.6 18.1907 6.6 18.342H6H5.4C5.4 18.8522 5.81326 19.2669 6.32447 19.2669V18.6669Z"
                                                            fill="#002449"
                                                        />
                                                    </svg>
                                            )}
                              </span>
                              <span
                                className={`feed-icon ${msg.isFeedback === "true" ? "disliked" : ""}`}  
                                onClick={() => {
                                  setResponseID(msg.responseId);
                                  setSelectedFeedback(null);
                                  setShowFeedbackModal(true);
                                  setIsSatifaction(false);
                                  //setCommentValidation(false);
                                  commentValidation = false;
                                  setFeedbackText("");
                                  SetFeedbackIndex(index);
                                }}
                              >{msg.isFeedback === "false" ? (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M13.513 5.15678L13.9833 7.87662C14.1008 8.55594 13.5784 9.17728 12.8897 9.17728H9.43566C9.09333 9.17728 8.83264 9.48456 8.88806 9.82276L9.32984 12.5191C9.40161 12.9572 9.38111 13.4054 9.26966 13.8351C9.17733 14.191 8.90272 14.4768 8.54158 14.5928L8.44493 14.6238C8.22667 14.694 7.98845 14.6776 7.78267 14.5785C7.55617 14.4693 7.39046 14.2703 7.32905 14.0335L7.01191 12.8109C6.911 12.4219 6.76402 12.0464 6.5745 11.6917C6.2976 11.1733 5.86948 10.7584 5.42446 10.375L4.4653 9.54842C4.19486 9.31538 4.05284 8.96638 4.08361 8.61048L4.62505 2.3487C4.67472 1.77434 5.15492 1.33341 5.73077 1.33341H8.82985C11.1507 1.33341 13.1314 2.95049 13.513 5.15678Z" fill="#CE0016" />
                                                <path d="M13.9833 7.87662L13.3921 7.97886V7.97886L13.9833 7.87662ZM13.513 5.15678L12.9217 5.25902V5.25902L13.513 5.15678ZM4.62505 2.3487L4.02728 2.29701H4.02728L4.62505 2.3487ZM4.08361 8.61048L4.68138 8.66217V8.66217L4.08361 8.61048ZM9.32984 12.5191L9.92194 12.4221V12.4221L9.32984 12.5191ZM8.88806 9.82276L9.48016 9.72575V9.72575L8.88806 9.82276ZM4.4653 9.54842L4.07363 10.0029H4.07363L4.4653 9.54842ZM5.42446 10.375L5.81613 9.92043H5.81613L5.42446 10.375ZM7.01191 12.8109L6.43113 12.9616V12.9616L7.01191 12.8109ZM7.32905 14.0335L7.90982 13.8828L7.90982 13.8828L7.32905 14.0335ZM8.44493 14.6238L8.26142 14.0526L8.26142 14.0526L8.44493 14.6238ZM8.54158 14.5928L8.72509 15.164L8.72509 15.164L8.54158 14.5928ZM6.5745 11.6917L7.10373 11.409L7.10373 11.409L6.5745 11.6917ZM9.26966 13.8351L8.68888 13.6844V13.6844L9.26966 13.8351ZM7.78267 14.5785L7.52221 15.119L7.52221 15.119L7.78267 14.5785ZM13.9833 7.87662L13.3921 7.97886L12.9217 5.25902L13.513 5.15678L14.1042 5.05454L14.5745 7.77438L13.9833 7.87662ZM8.82985 1.33341V1.93341H5.73077V1.33341V0.733415H8.82985V1.33341ZM4.62505 2.3487L5.22282 2.40039L4.68138 8.66217L4.08361 8.61048L3.48584 8.55879L4.02728 2.29701L4.62505 2.3487ZM13.513 5.15678L12.9217 5.25902C12.5926 3.35581 10.8747 1.93341 8.82985 1.93341V1.33341V0.733415C11.4267 0.733415 13.6702 2.54516 14.1042 5.05454L13.513 5.15678ZM9.32984 12.5191L8.73773 12.6161L8.29595 9.91977L8.88806 9.82276L9.48016 9.72575L9.92194 12.4221L9.32984 12.5191ZM4.4653 9.54842L4.85697 9.0939L5.81613 9.92043L5.42446 10.375L5.03278 10.8295L4.07363 10.0029L4.4653 9.54842ZM7.01191 12.8109L7.59268 12.6603L7.90982 13.8828L7.32905 14.0335L6.74827 14.1841L6.43113 12.9616L7.01191 12.8109ZM8.44493 14.6238L8.26142 14.0526L8.35807 14.0216L8.54158 14.5928L8.72509 15.164L8.62845 15.1951L8.44493 14.6238ZM6.5745 11.6917L7.10373 11.409C7.3154 11.8052 7.47978 12.225 7.59268 12.6603L7.01191 12.8109L6.43113 12.9616C6.34223 12.6189 6.21263 12.2877 6.04528 11.9744L6.5745 11.6917ZM8.54158 14.5928L8.35807 14.0216C8.53097 13.966 8.65012 13.8338 8.68888 13.6844L9.26966 13.8351L9.85044 13.9857C9.70454 14.5481 9.27447 14.9876 8.72509 15.164L8.54158 14.5928ZM7.32905 14.0335L7.90982 13.8828C7.92556 13.9435 7.97042 14.0029 8.04313 14.038L7.78267 14.5785L7.52221 15.119C7.14193 14.9358 6.85537 14.597 6.74827 14.1841L7.32905 14.0335ZM7.78267 14.5785L8.04313 14.038C8.10977 14.0701 8.18903 14.0759 8.26142 14.0526L8.44493 14.6238L8.62845 15.1951C8.26432 15.3121 7.86713 15.2852 7.52221 15.119L7.78267 14.5785ZM9.43566 9.17728V8.57728H12.8897V9.17728V9.77728H9.43566V9.17728ZM9.32984 12.5191L9.92194 12.4221C10.0072 12.9426 9.98287 13.4752 9.85044 13.9857L9.26966 13.8351L8.68888 13.6844C8.77936 13.3356 8.796 12.9718 8.73773 12.6161L9.32984 12.5191ZM5.73077 1.33341V1.93341C5.46681 1.93341 5.24571 2.13565 5.22282 2.40039L4.62505 2.3487L4.02728 2.29701C4.10372 1.41303 4.84302 0.733415 5.73077 0.733415V1.33341ZM5.42446 10.375L5.81613 9.92043C6.27101 10.3124 6.77165 10.7873 7.10373 11.409L6.5745 11.6917L6.04528 11.9744C5.82356 11.5593 5.46795 11.2045 5.03278 10.8295L5.42446 10.375ZM13.9833 7.87662L14.5745 7.77438C14.7553 8.8197 13.9514 9.77728 12.8897 9.77728V9.17728V8.57728C13.2053 8.57728 13.4463 8.29219 13.3921 7.97886L13.9833 7.87662ZM8.88806 9.82276L8.29595 9.91977C8.18083 9.21714 8.72243 8.57728 9.43566 8.57728V9.17728V9.77728C9.46423 9.77728 9.48446 9.75198 9.48016 9.72575L8.88806 9.82276ZM4.08361 8.61048L4.68138 8.66217C4.6672 8.82616 4.73267 8.98679 4.85697 9.0939L4.4653 9.54842L4.07363 10.0029C3.65705 9.64397 3.43847 9.10659 3.48584 8.55879L4.08361 8.61048Z" fill="#CE0016" />
                                                <path opacity="0.5" d="M2.64773 1.68599L2.04996 1.6343H2.04996L2.64773 1.68599ZM2 9.177L2.59777 9.22869C2.57009 9.54881 2.29514 9.7903 1.97413 9.77644C1.65312 9.76259 1.4 9.49831 1.4 9.177H2ZM2.64773 1.68599L3.2455 1.73768L2.59777 9.22869L2 9.177L1.40223 9.12531L2.04996 1.6343L2.64773 1.68599ZM2 1.65798H2.6V9.177H2H1.4V1.65798H2ZM2.64773 1.68599L2.04996 1.6343C2.03613 1.79429 2.16222 1.93314 2.32447 1.93314V1.33314V0.733136C2.8672 0.733136 3.29215 1.19819 3.2455 1.73768L2.64773 1.68599ZM2.32447 1.33314V1.93314C2.47728 1.93314 2.6 1.8093 2.6 1.65798H2H1.4C1.4 1.14784 1.81326 0.733136 2.32447 0.733136V1.33314Z" fill="#CE0016" />
                                            </svg>): (<svg
                                  xmlns = "http://www.w3.org/2000/svg"
                                  width = "24"
                                  height = "24"
                                  viewBox = "0 0 24 24"
                                  fill = "none"
                                            >
                                  <rect
                                    width = "24"
                                    height = "24"
                                    rx = "12"
                                    transform = "matrix(-1 0 0 1 24 0)"
                                    fill = "#F5F5F5"
                                  />
                                            <path
                                                d="M17.9832 11.8766L17.392 11.9789V11.9789L17.9832 11.8766ZM17.5128 9.15678L16.9216 9.25902V9.25902L17.5128 9.15678ZM8.62493 6.3487L8.02716 6.29701H8.02716L8.62493 6.3487ZM8.08349 12.6105L8.68126 12.6622V12.6622L8.08349 12.6105ZM13.3297 16.5191L13.9218 16.4221V16.4221L13.3297 16.5191ZM12.8879 13.8228L13.48 13.7257V13.7257L12.8879 13.8228ZM8.46518 13.5484L8.0735 14.0029H8.0735L8.46518 13.5484ZM9.42434 14.375L9.81601 13.9204H9.81601L9.42434 14.375ZM11.0118 16.8109L10.431 16.9616V16.9616L11.0118 16.8109ZM11.3289 18.0335L11.9097 17.8828L11.9097 17.8828L11.3289 18.0335ZM12.4448 18.6238L12.2613 18.0526L12.2613 18.0526L12.4448 18.6238ZM12.5415 18.5928L12.725 19.164L12.725 19.164L12.5415 18.5928ZM10.5744 15.6917L11.1036 15.409L11.1036 15.409L10.5744 15.6917ZM13.2695 17.8351L12.6888 17.6844V17.6844L13.2695 17.8351ZM11.7825 18.5785L11.5221 19.119L11.5221 19.119L11.7825 18.5785ZM17.9832 11.8766L17.392 11.9789L16.9216 9.25902L17.5128 9.15678L18.1041 9.05454L18.5744 11.7744L17.9832 11.8766ZM12.8297 5.33341V5.93341H9.73065V5.33341V4.73341H12.8297V5.33341ZM8.62493 6.3487L9.2227 6.40039L8.68126 12.6622L8.08349 12.6105L7.48572 12.5588L8.02716 6.29701L8.62493 6.3487ZM17.5128 9.15678L16.9216 9.25902C16.5925 7.35581 14.8746 5.93341 12.8297 5.93341V5.33341V4.73341C15.4266 4.73341 17.6701 6.54516 18.1041 9.05454L17.5128 9.15678ZM13.3297 16.5191L12.7376 16.6161L12.2958 13.9198L12.8879 13.8228L13.48 13.7257L13.9218 16.4221L13.3297 16.5191ZM8.46518 13.5484L8.85685 13.0939L9.81601 13.9204L9.42434 14.375L9.03266 14.8295L8.0735 14.0029L8.46518 13.5484ZM11.0118 16.8109L11.5926 16.6603L11.9097 17.8828L11.3289 18.0335L10.7481 18.1841L10.431 16.9616L11.0118 16.8109ZM12.4448 18.6238L12.2613 18.0526L12.3579 18.0216L12.5415 18.5928L12.725 19.164L12.6283 19.1951L12.4448 18.6238ZM10.5744 15.6917L11.1036 15.409C11.3153 15.8052 11.4797 16.225 11.5926 16.6603L11.0118 16.8109L10.431 16.9616C10.3421 16.6189 10.2125 16.2877 10.0452 15.9744L10.5744 15.6917ZM12.5415 18.5928L12.3579 18.0216C12.5309 17.966 12.65 17.8338 12.6888 17.6844L13.2695 17.8351L13.8503 17.9857C13.7044 18.5481 13.2743 18.9876 12.725 19.164L12.5415 18.5928ZM11.3289 18.0335L11.9097 17.8828C11.9254 17.9435 11.9703 18.0029 12.043 18.038L11.7825 18.5785L11.5221 19.119C11.1418 18.9358 10.8553 18.597 10.7481 18.1841L11.3289 18.0335ZM11.7825 18.5785L12.043 18.038C12.1097 18.0701 12.1889 18.0759 12.2613 18.0526L12.4448 18.6238L12.6283 19.1951C12.2642 19.3121 11.867 19.2852 11.5221 19.119L11.7825 18.5785ZM13.4355 13.1773V12.5773H16.8896V13.1773V13.7773H13.4355V13.1773ZM13.3297 16.5191L13.9218 16.4221C14.0071 16.9426 13.9827 17.4752 13.8503 17.9857L13.2695 17.8351L12.6888 17.6844C12.7792 17.3356 12.7959 16.9718 12.7376 16.6161L13.3297 16.5191ZM9.73065 5.33341V5.93341C9.46669 5.93341 9.24559 6.13565 9.2227 6.40039L8.62493 6.3487L8.02716 6.29701C8.1036 5.41303 8.8429 4.73341 9.73065 4.73341V5.33341ZM9.42434 14.375L9.81601 13.9204C10.2709 14.3124 10.7715 14.7873 11.1036 15.409L10.5744 15.6917L10.0452 15.9744C9.82344 15.5593 9.46783 15.2045 9.03266 14.8295L9.42434 14.375ZM17.9832 11.8766L18.5744 11.7744C18.7552 12.8197 17.9513 13.7773 16.8896 13.7773V13.1773V12.5773C17.2052 12.5773 17.4461 12.2922 17.392 11.9789L17.9832 11.8766ZM12.8879 13.8228L12.2958 13.9198C12.1807 13.2171 12.7223 12.5773 13.4355 12.5773V13.1773V13.7773C13.4641 13.7773 13.4843 13.752 13.48 13.7257L12.8879 13.8228ZM8.08349 12.6105L8.68126 12.6622C8.66708 12.8262 8.73255 12.9868 8.85685 13.0939L8.46518 13.5484L8.0735 14.0029C7.65693 13.644 7.43835 13.1066 7.48572 12.5588L8.08349 12.6105Z"
                                                fill="#002449"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M6.64773 5.68599L6.04996 5.6343H6.04996L6.64773 5.68599ZM6 13.177L6.59777 13.2287C6.57009 13.5488 6.29514 13.7903 5.97413 13.7764C5.65312 13.7626 5.4 13.4983 5.4 13.177H6ZM6.64773 5.68599L7.2455 5.73768L6.59777 13.2287L6 13.177L5.40223 13.1253L6.04996 5.6343L6.64773 5.68599ZM6 5.65798H6.6V13.177H6H5.4V5.65798H6ZM6.64773 5.68599L6.04996 5.6343C6.03613 5.79429 6.16222 5.93314 6.32447 5.93314V5.33314V4.73314C6.8672 4.73314 7.29215 5.19819 7.2455 5.73768L6.64773 5.68599ZM6.32447 5.33314V5.93314C6.47728 5.93314 6.6 5.8093 6.6 5.65798H6H5.4C5.4 5.14784 5.81326 4.73314 6.32447 4.73314V5.33314Z"
                                                fill="#002449"
                                            />
                                        </svg>)}
                                
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                )}

                {activeTab === CommonObj.PolicyName && (
                  <div className="queries-container fade-in">
                    <div className="button-grid fade-in"></div>
                    {policymessages.map((msg, index) => (
                      <>
                        {msg.sender === "user" && (
                          <div className="fade-in">
                            <div className="user-msg-row">
                              <div className="user-reply-bubble clickable">
                                {parse(msg.text)}
                              </div>
                              <div className="user-tag-cw">{UserName}</div>
                            </div>
                          </div>
                        )}

                        {msg.sender === "bot" && (
                          <div className="fade-in">
                            <div className="bot-msg-row">
                              <div className="bot-side-avatar">
                                <img src={chatavatr} alt="Bot" />
                              </div>
                              <RenderHTML htmlContent={msg.text} />
                            </div>
                            <div className="feedback-icons-row">
                              <span
                                className="feed-icon"
                                onClick={() => {
                                  setResponseID(msg.responseId);
                                  setSelectedFeedback(null);
                                  setShowFeedbackModal(true);
                                  setIsSatifaction(true);
                                  //setCommentValidation(false);
                                  commentValidation = false;
                                  setFeedbackText("");
                                  SetFeedbackIndex(index);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <rect
                                    width="24"
                                    height="24"
                                    rx="12"
                                    transform="matrix(-1 0 0 1 24 0)"
                                    fill="#F5F5F5"
                                  ></rect>
                                  <path
                                    d="M17.9832 12.1234L17.392 12.0211V12.0211L17.9832 12.1234ZM17.5128 14.8432L16.9216 14.741V14.741L17.5128 14.8432ZM8.62493 17.6513L8.02716 17.703H8.02716L8.62493 17.6513ZM8.08349 11.3895L8.68126 11.3378V11.3378L8.08349 11.3895ZM13.3297 7.48087L13.9218 7.57788V7.57788L13.3297 7.48087ZM12.8879 10.1772L13.48 10.2743V10.2743L12.8879 10.1772ZM8.46518 10.4516L8.0735 9.99705L8.0735 9.99705L8.46518 10.4516ZM9.42434 9.62505L9.81601 10.0796H9.81601L9.42434 9.62505ZM11.0118 7.18908L10.431 7.03843V7.03843L11.0118 7.18908ZM11.3289 5.96651L11.9097 6.11717L11.9097 6.11717L11.3289 5.96651ZM12.4448 5.37615L12.2613 5.9474L12.2613 5.9474L12.4448 5.37615ZM12.5415 5.4072L12.725 4.83596L12.725 4.83595L12.5415 5.4072ZM10.5744 8.30833L11.1036 8.59103V8.59103L10.5744 8.30833ZM13.2695 6.16494L12.6888 6.31559V6.31559L13.2695 6.16494ZM11.7825 5.42151L11.5221 4.881V4.881L11.7825 5.42151ZM17.9832 12.1234L17.392 12.0211L16.9216 14.741L17.5128 14.8432L18.1041 14.9455L18.5744 12.2256L17.9832 12.1234ZM12.8297 18.6666V18.0666H9.73065V18.6666V19.2666H12.8297V18.6666ZM8.62493 17.6513L9.2227 17.5996L8.68126 11.3378L8.08349 11.3895L7.48572 11.4412L8.02716 17.703L8.62493 17.6513ZM17.5128 14.8432L16.9216 14.741C16.5925 16.6442 14.8746 18.0666 12.8297 18.0666V18.6666V19.2666C15.4266 19.2666 17.6701 17.4548 18.1041 14.9455L17.5128 14.8432ZM13.3297 7.48087L12.7376 7.38385L12.2958 10.0802L12.8879 10.1772L13.48 10.2743L13.9218 7.57788L13.3297 7.48087ZM8.46518 10.4516L8.85685 10.9061L9.81601 10.0796L9.42434 9.62505L9.03266 9.17052L8.0735 9.99705L8.46518 10.4516ZM11.0118 7.18908L11.5926 7.33974L11.9097 6.11717L11.3289 5.96651L10.7481 5.81586L10.431 7.03843L11.0118 7.18908ZM12.4448 5.37615L12.2613 5.9474L12.3579 5.97845L12.5415 5.4072L12.725 4.83595L12.6283 4.80491L12.4448 5.37615ZM10.5744 8.30833L11.1036 8.59103C11.3153 8.19477 11.4797 7.775 11.5926 7.33974L11.0118 7.18908L10.431 7.03843C10.3421 7.38114 10.2125 7.71233 10.0452 8.02563L10.5744 8.30833ZM12.5415 5.4072L12.3579 5.97845C12.5309 6.03399 12.65 6.16617 12.6888 6.31559L13.2695 6.16494L13.8503 6.01428C13.7044 5.45185 13.2743 5.01244 12.725 4.83596L12.5415 5.4072ZM11.3289 5.96651L11.9097 6.11717C11.9254 6.05652 11.9703 5.99707 12.043 5.96203L11.7825 5.42151L11.5221 4.881C11.1418 5.06425 10.8553 5.40297 10.7481 5.81586L11.3289 5.96651ZM11.7825 5.42151L12.043 5.96203C12.1097 5.92992 12.1889 5.92415 12.2613 5.9474L12.4448 5.37615L12.6283 4.80491C12.2642 4.68793 11.867 4.71479 11.5221 4.881L11.7825 5.42151ZM13.4355 10.8227V11.4227H16.8896V10.8227V10.2227H13.4355V10.8227ZM13.3297 7.48087L13.9218 7.57788C14.0071 7.05739 13.9827 6.5248 13.8503 6.01428L13.2695 6.16494L12.6888 6.31559C12.7792 6.66437 12.7959 7.02825 12.7376 7.38385L13.3297 7.48087ZM9.73065 18.6666V18.0666C9.46669 18.0666 9.24559 17.8644 9.2227 17.5996L8.62493 17.6513L8.02716 17.703C8.1036 18.587 8.8429 19.2666 9.73065 19.2666V18.6666ZM9.42434 9.62505L9.81601 10.0796C10.2709 9.68759 10.7715 9.2127 11.1036 8.59103L10.5744 8.30833L10.0452 8.02563C9.82344 8.4407 9.46783 8.79553 9.03266 9.17052L9.42434 9.62505ZM17.9832 12.1234L18.5744 12.2256C18.7552 11.1803 17.9513 10.2227 16.8896 10.2227V10.8227V11.4227C17.2052 11.4227 17.4461 11.7078 17.392 12.0211L17.9832 12.1234ZM12.8879 10.1772L12.2958 10.0802C12.1807 10.7829 12.7223 11.4227 13.4355 11.4227V10.8227V10.2227C13.4641 10.2227 13.4843 10.248 13.48 10.2743L12.8879 10.1772ZM8.08349 11.3895L8.68126 11.3378C8.66708 11.1738 8.73255 11.0132 8.85685 10.9061L8.46518 10.4516L8.0735 9.99705C7.65693 10.356 7.43835 10.8934 7.48572 11.4412L8.08349 11.3895Z"
                                    fill="#002449"
                                  ></path>
                                  <path
                                    opacity="0.5"
                                    d="M6.64773 18.314L6.04996 18.3657L6.04996 18.3657L6.64773 18.314ZM6 10.823L6.59777 10.7713C6.57009 10.4512 6.29514 10.2097 5.97413 10.2236C5.65312 10.2374 5.4 10.5017 5.4 10.823H6ZM6.64773 18.314L7.2455 18.2623L6.59777 10.7713L6 10.823L5.40223 10.8747L6.04996 18.3657L6.64773 18.314ZM6 18.342H6.6V10.823H6H5.4V18.342H6ZM6.64773 18.314L6.04996 18.3657C6.03613 18.2057 6.16222 18.0669 6.32447 18.0669V18.6669V19.2669C6.8672 19.2669 7.29215 18.8018 7.2455 18.2623L6.64773 18.314ZM6.32447 18.6669V18.0669C6.47728 18.0669 6.6 18.1907 6.6 18.342H6H5.4C5.4 18.8522 5.81326 19.2669 6.32447 19.2669V18.6669Z"
                                    fill="#002449"
                                  ></path>
                                </svg>
                              </span>
                              <span
                                className="feed-icon"
                                onClick={() => {
                                  setResponseID(msg.responseId);
                                  setSelectedFeedback(null);
                                  setShowFeedbackModal(true);
                                  setIsSatifaction(false);
                                  //setCommentValidation(false);
                                  commentValidation = false;
                                  setFeedbackText("");
                                   SetFeedbackIndex(index);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <rect
                                    width="24"
                                    height="24"
                                    rx="12"
                                    transform="matrix(-1 0 0 1 24 0)"
                                    fill="#F5F5F5"
                                  ></rect>
                                  <path
                                    d="M17.9832 11.8766L17.392 11.9789V11.9789L17.9832 11.8766ZM17.5128 9.15678L16.9216 9.25902V9.25902L17.5128 9.15678ZM8.62493 6.3487L8.02716 6.29701H8.02716L8.62493 6.3487ZM8.08349 12.6105L8.68126 12.6622V12.6622L8.08349 12.6105ZM13.3297 16.5191L13.9218 16.4221V16.4221L13.3297 16.5191ZM12.8879 13.8228L13.48 13.7257V13.7257L12.8879 13.8228ZM8.46518 13.5484L8.0735 14.0029H8.0735L8.46518 13.5484ZM9.42434 14.375L9.81601 13.9204H9.81601L9.42434 14.375ZM11.0118 16.8109L10.431 16.9616V16.9616L11.0118 16.8109ZM11.3289 18.0335L11.9097 17.8828L11.9097 17.8828L11.3289 18.0335ZM12.4448 18.6238L12.2613 18.0526L12.2613 18.0526L12.4448 18.6238ZM12.5415 18.5928L12.725 19.164L12.725 19.164L12.5415 18.5928ZM10.5744 15.6917L11.1036 15.409L11.1036 15.409L10.5744 15.6917ZM13.2695 17.8351L12.6888 17.6844V17.6844L13.2695 17.8351ZM11.7825 18.5785L11.5221 19.119L11.5221 19.119L11.7825 18.5785ZM17.9832 11.8766L17.392 11.9789L16.9216 9.25902L17.5128 9.15678L18.1041 9.05454L18.5744 11.7744L17.9832 11.8766ZM12.8297 5.33341V5.93341H9.73065V5.33341V4.73341H12.8297V5.33341ZM8.62493 6.3487L9.2227 6.40039L8.68126 12.6622L8.08349 12.6105L7.48572 12.5588L8.02716 6.29701L8.62493 6.3487ZM17.5128 9.15678L16.9216 9.25902C16.5925 7.35581 14.8746 5.93341 12.8297 5.93341V5.33341V4.73341C15.4266 4.73341 17.6701 6.54516 18.1041 9.05454L17.5128 9.15678ZM13.3297 16.5191L12.7376 16.6161L12.2958 13.9198L12.8879 13.8228L13.48 13.7257L13.9218 16.4221L13.3297 16.5191ZM8.46518 13.5484L8.85685 13.0939L9.81601 13.9204L9.42434 14.375L9.03266 14.8295L8.0735 14.0029L8.46518 13.5484ZM11.0118 16.8109L11.5926 16.6603L11.9097 17.8828L11.3289 18.0335L10.7481 18.1841L10.431 16.9616L11.0118 16.8109ZM12.4448 18.6238L12.2613 18.0526L12.3579 18.0216L12.5415 18.5928L12.725 19.164L12.6283 19.1951L12.4448 18.6238ZM10.5744 15.6917L11.1036 15.409C11.3153 15.8052 11.4797 16.225 11.5926 16.6603L11.0118 16.8109L10.431 16.9616C10.3421 16.6189 10.2125 16.2877 10.0452 15.9744L10.5744 15.6917ZM12.5415 18.5928L12.3579 18.0216C12.5309 17.966 12.65 17.8338 12.6888 17.6844L13.2695 17.8351L13.8503 17.9857C13.7044 18.5481 13.2743 18.9876 12.725 19.164L12.5415 18.5928ZM11.3289 18.0335L11.9097 17.8828C11.9254 17.9435 11.9703 18.0029 12.043 18.038L11.7825 18.5785L11.5221 19.119C11.1418 18.9358 10.8553 18.597 10.7481 18.1841L11.3289 18.0335ZM11.7825 18.5785L12.043 18.038C12.1097 18.0701 12.1889 18.0759 12.2613 18.0526L12.4448 18.6238L12.6283 19.1951C12.2642 19.3121 11.867 19.2852 11.5221 19.119L11.7825 18.5785ZM13.4355 13.1773V12.5773H16.8896V13.1773V13.7773H13.4355V13.1773ZM13.3297 16.5191L13.9218 16.4221C14.0071 16.9426 13.9827 17.4752 13.8503 17.9857L13.2695 17.8351L12.6888 17.6844C12.7792 17.3356 12.7959 16.9718 12.7376 16.6161L13.3297 16.5191ZM9.73065 5.33341V5.93341C9.46669 5.93341 9.24559 6.13565 9.2227 6.40039L8.62493 6.3487L8.02716 6.29701C8.1036 5.41303 8.8429 4.73341 9.73065 4.73341V5.33341ZM9.42434 14.375L9.81601 13.9204C10.2709 14.3124 10.7715 14.7873 11.1036 15.409L10.5744 15.6917L10.0452 15.9744C9.82344 15.5593 9.46783 15.2045 9.03266 14.8295L9.42434 14.375ZM17.9832 11.8766L18.5744 11.7744C18.7552 12.8197 17.9513 13.7773 16.8896 13.7773V13.1773V12.5773C17.2052 12.5773 17.4461 12.2922 17.392 11.9789L17.9832 11.8766ZM12.8879 13.8228L12.2958 13.9198C12.1807 13.2171 12.7223 12.5773 13.4355 12.5773V13.1773V13.7773C13.4641 13.7773 13.4843 13.752 13.48 13.7257L12.8879 13.8228ZM8.08349 12.6105L8.68126 12.6622C8.66708 12.8262 8.73255 12.9868 8.85685 13.0939L8.46518 13.5484L8.0735 14.0029C7.65693 13.644 7.43835 13.1066 7.48572 12.5588L8.08349 12.6105Z"
                                    fill="#002449"
                                  ></path>
                                  <path
                                    opacity="0.5"
                                    d="M6.64773 5.68599L6.04996 5.6343H6.04996L6.64773 5.68599ZM6 13.177L6.59777 13.2287C6.57009 13.5488 6.29514 13.7903 5.97413 13.7764C5.65312 13.7626 5.4 13.4983 5.4 13.177H6ZM6.64773 5.68599L7.2455 5.73768L6.59777 13.2287L6 13.177L5.40223 13.1253L6.04996 5.6343L6.64773 5.68599ZM6 5.65798H6.6V13.177H6H5.4V5.65798H6ZM6.64773 5.68599L6.04996 5.6343C6.03613 5.79429 6.16222 5.93314 6.32447 5.93314V5.33314V4.73314C6.8672 4.73314 7.29215 5.19819 7.2455 5.73768L6.64773 5.68599ZM6.32447 5.33314V5.93314C6.47728 5.93314 6.6 5.8093 6.6 5.65798H6H5.4C5.4 5.14784 5.81326 4.73314 6.32447 4.73314V5.33314Z"
                                    fill="#002449"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                )}
                <div ref={scrollRef} style={{ height: "5px" }} />
              </div>
            </div>

            <div className="bottom-input-bar">
              <button
                className="hamburger-btn"
                onClick={() => {
                  window.parent.postMessage("HIDE_IMAGE", "*");
                  setIsModalOpen(true);
                  setPdfSample("https://myconnect.rrd.com/ChatBot.html");
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 12H20"
                    stroke="#002449"
                    strokeOpacity="0.5"
                    strokeWidth="1.77778"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M4 6.66699H20"
                    stroke="#002449"
                    strokeWidth="1.77778"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M4 17.3337H20"
                    stroke="#002449"
                    strokeWidth="1.77778"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
              <input
                ref={inputRef}
                type="text"
                className="chat-input-field"
                placeholder="Got a question?"
                maxLength={200}
                value={input}
                onChange={(e) => {
                  setInput(e.target.value);
                  setDisabledSend(e.target.value.length != 0 ? false : true);
                }}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
              />
              <button className="mic-btn" onClick={btnSubmit} title="Send">
                <span
                  className={
                    disabledSend ? "disabled-send-arrow-btn" : "send-arrow-btn"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1_4991)">
                      <path
                        d="M0.0712488 1.56006C-0.0921196 1.1129 0.0308277 0.617745 0.384933 0.299008C0.738196 -0.0184658 1.24135 -0.0900448 1.6683 0.117534L9.28514 3.6729C9.69356 3.86406 9.98577 4.21311 10.1041 4.62996H1.70325L0.0952488 1.61353C0.0864067 1.59627 0.0784067 1.57817 0.0712488 1.56006ZM1.70914 5.47248L0.128933 8.49354C0.120091 8.51038 0.112512 8.52722 0.106196 8.5449C-0.0567512 8.99248 0.0674593 9.4868 0.421565 9.80511C0.640933 10.0017 0.917986 10.1032 1.19672 10.1032C1.36893 10.1032 1.54156 10.0645 1.70241 9.98575L9.28598 6.4329C9.69567 6.2409 9.98746 5.89059 10.1049 5.4729H1.70914V5.47248Z"
                        fill="url(#paint0_linear_1_4991)"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_1_4991"
                        x1="10.2124"
                        y1="4.9284"
                        x2="0.613807"
                        y2="2.50112"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#009DDB" />
                        <stop offset="1" stopColor="#204D92" />
                      </linearGradient>
                      <clipPath id="clip0_1_4991">
                        <rect width="10.1053" height="10.1053" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </button>
              {information && (
                <div className="disclaimer">
                  <p>
                    <b>Disclaimer:</b> I'm an AI tool and can make mistakes. Do not enter any Personally Identifiable Information (PII) or confidential company data. Conversations are logged 
                    for quality and compliance.
                  </p>
                </div>
              )}
            </div>
          </>
        </div>
      </div>
    );
  }
};

export default ChatBot;
